class AccountVerification {
  __typename;
  account_verification_status;
  /** The BO user's ID was assigned to this KYC case */
  assigned_user_id;
  brand;
  documents;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** if auth token contains `full-player` or `full-player:read` email is visible, else it is masked
   */
  email;
  id;
  /** list of reasons for initiating KYC case; optional for backward compatibility */
  init_reason_codes;
  /** Timestamp when KYC was initiated first time */
  initiated_at;
  iso_alpha2_country_code;
  kyc_case_id;
  kyc_manual;
  /** Latest timestamp when KYC was initiated or reopened */
  latest_opened_at;
  /** Latest timestamp when KYC Document was uploaded by player */
  latest_uploaded_at;
  license_type;
  /** last list of reasons specified when changing the KYC status; optional for backward compatibility */
  reason_codes;
  status_log;
  type;
  uid;
  /** player's labels */
  user_labels;
  username;
}
class AccountVerificationFilter {
  account_verification_status;
  brand;
  /** filter KYC cases initiated with any reason from the list */
  init_reason_codes;
  initiated_at;
  iso_alpha2_country_code;
  kyc_status;
  latest_opened_at;
  license_type;
  /** KYC case filter for the latest status change reasons */
  reason_codes;
  text;
  type;
}
class AccountVerificationInput {
  account_verification_status;
  documents;
  email;
  id;
  /** list of reasons for initiating KYC case; optional for backward compatibility */
  init_reason_codes;
  initiated_at;
  iso_alpha2_country_code;
  kyc_case_id;
  kyc_manual;
  latest_opened_at;
  /** last list of reasons specified when changing the KYC status; optional for backward compatibility */
  reason_codes;
  status_log;
  type;
  uid;
  username;
}
class AccountVerificationPage {
  __typename;
  items;
  total_count;
}
var AccountVerificationStatus = /* @__PURE__ */ ((AccountVerificationStatus2) => {
  AccountVerificationStatus2["Approved"] = "Approved";
  AccountVerificationStatus2["DeniedDepositKyc"] = "DeniedDepositKYC";
  AccountVerificationStatus2["DeniedLoginKyc"] = "DeniedLoginKYC";
  AccountVerificationStatus2["DeniedNdrpKyc"] = "DeniedNdrpKYC";
  AccountVerificationStatus2["DeniedPaymentKyc"] = "DeniedPaymentKYC";
  AccountVerificationStatus2["DeniedWithdrawalKyc"] = "DeniedWithdrawalKYC";
  AccountVerificationStatus2["InitDepositKyc"] = "InitDepositKYC";
  AccountVerificationStatus2["InitLoginKyc"] = "InitLoginKYC";
  AccountVerificationStatus2["InitNdrpKyc"] = "InitNdrpKYC";
  AccountVerificationStatus2["InitPaymentKyc"] = "InitPaymentKYC";
  AccountVerificationStatus2["InitWithdrawalKyc"] = "InitWithdrawalKYC";
  AccountVerificationStatus2["OnHoldDepositKyc"] = "OnHoldDepositKYC";
  AccountVerificationStatus2["OnHoldLoginKyc"] = "OnHoldLoginKYC";
  AccountVerificationStatus2["OnHoldPaymentKyc"] = "OnHoldPaymentKYC";
  AccountVerificationStatus2["OnHoldWithdrawalKyc"] = "OnHoldWithdrawalKYC";
  return AccountVerificationStatus2;
})(AccountVerificationStatus || {});
class AccountVerificationStatusLog {
  __typename;
  account_verification_status;
  kyc_status;
  logged_at;
  reason_codes;
}
class AccountVerificationStatusLogInput {
  account_verification_status;
  kyc_status;
  logged_at;
}
var AccountVerificationType = /* @__PURE__ */ ((AccountVerificationType2) => {
  AccountVerificationType2["NdrpVerification"] = "NdrpVerification";
  AccountVerificationType2["Payment"] = "Payment";
  AccountVerificationType2["Security"] = "Security";
  return AccountVerificationType2;
})(AccountVerificationType || {});
class ActionFilter {
  action;
  round;
}
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["AddActionTime"] = "AddActionTime";
  ActionType2["Allin"] = "Allin";
  ActionType2["Bet"] = "Bet";
  ActionType2["Call"] = "Call";
  ActionType2["CallMuck"] = "CallMuck";
  ActionType2["Check"] = "Check";
  ActionType2["Fold"] = "Fold";
  ActionType2["HoleCards"] = "HoleCards";
  ActionType2["Null"] = "Null";
  ActionType2["Post"] = "Post";
  ActionType2["Raise"] = "Raise";
  ActionType2["SendCardCommon"] = "SendCard_Common";
  ActionType2["Straddle"] = "Straddle";
  return ActionType2;
})(ActionType || {});
class ActiveAccountVerification {
  __typename;
  payment;
  security;
}
class ActiveAccountVerificationInput {
  payment;
  security;
}
class AddSourceOfFundsInput {
  others_source_details;
  type;
  uid;
}
class AddUserLabelInput {
  label_ids;
  uid;
}
class AdjustAgentDebtInput {
  adjust_type;
  agent_uid;
  amount;
  transfer_date;
}
class AffiliateInput {
  btag;
}
class Affiliates {
  __typename;
  affiliated_date;
  btag;
  invite_code;
  notification_date;
}
class AffiliatesInput {
  affiliated_date;
  btag;
  invite_code;
  notification_date;
}
class AgentCommissionSubtypes {
  __typename;
  casino;
  poker;
  poker_cash_plo;
  poker_mtt;
  spins;
  sports;
}
class AgentCommissionSubtypesHistory {
  __typename;
  casino;
  poker;
  poker_cash_plo;
  poker_mtt;
  spins;
  sports;
}
class AgentCommissionSubtypesInput {
  casino;
  poker;
  poker_cash_plo;
  poker_mtt;
  spins;
  sports;
}
class AgentInfo {
  __typename;
  agent_granted_ts;
  /** @deprecated Used for backward compatability with igp-bo. Will be removed when all agents migrate to agent-bo */
  bo_agent_id;
  default_agent_revenue_share_history;
  /**
   * true when either `keycloak_user_id` or `bo_agent_id` exist
   *
   * default value: false
   */
  is_agent;
  keycloak_user_id;
}
class AgentInfoInput {
  agent_granted_ts;
  /** @deprecated Used for backward compatability with igp-bo. Will be removed when all agents migrate to agent-bo */
  bo_agent_id;
  default_agent_revenue_share_history;
}
class AgentNegativeCarryoverReport {
  __typename;
  agent_uid;
  debt_after_payment;
  debt_before_payment;
  debt_transaction;
  id;
  total_net_share;
  week_start_date_ts;
  weekly_actually_paid;
}
class AgentNegativeCarryoverReportPage {
  __typename;
  items;
  last_updated;
  total_count;
}
class AgentPathStatistics {
  __typename;
  active_player_number;
  agent_uid;
  path_to_subagent;
  registered_player_number;
}
class AgentPathStatisticsPage {
  __typename;
  items;
  total_count;
}
var AgentPlayerReportVersion = /* @__PURE__ */ ((AgentPlayerReportVersion2) => {
  AgentPlayerReportVersion2["Daily"] = "Daily";
  AgentPlayerReportVersion2["Weekly"] = "Weekly";
  return AgentPlayerReportVersion2;
})(AgentPlayerReportVersion || {});
class AgentPlayerReporting {
  __typename;
  bonus_summary;
  /**
   *  ### Policies: ###
   *
   * ** For all users: ** if auth token contains `full-player` or `full-player:read`  is visible, else it is masked
   */
  contact;
  deduction_summary;
  ggr_summary;
  highest_blind_level_is_pro_nlhe;
  iso_alpha2_country_code;
  ngr_summary;
  other_summary;
  player_games_summary;
  pro_summary;
  referrer_agent_id;
  referrer_agent_username;
  register_marketing_code;
  uid;
  username;
}
class AgentPlayerReportingFilter {
  referrer;
  text;
  transaction_started_ts;
}
class AgentPlayerReportingFilterVn {
  referrer;
  report_version;
  text;
  transaction_started_ts;
}
class AgentPlayerReportingKr {
  __typename;
  casino_share;
  poker_share;
  /** is referee player or subagent */
  referee_type;
  /** player id of agent */
  referrer_agent_id;
  referrer_agent_username;
  /** is revenue generated directly during playing or as a subagent */
  revenue_share_type;
  total_share;
  /** player id of referee */
  uid;
}
class AgentPlayerReportingKrPage {
  __typename;
  /** array of reports for sub agents and players invited by korean agents */
  items;
  /** summary with summed up values of reports for all pages */
  summary;
  total_count;
}
class AgentPlayerReportingKrSummary {
  __typename;
  casino_share;
  poker_share;
  total_share;
}
class AgentPlayerReportingPage {
  __typename;
  /** array of reports for sub agents and players invited by agents */
  items;
  /** summary with summed up values of reports for all pages */
  summary;
  total_count;
}
class AgentPlayerReportingSummary {
  __typename;
  bonus_summary;
  deduction_summary;
  ggr_summary;
  ngr_summary;
  other_summary;
  player_games_summary;
  pro_summary;
}
class AgentPlayerReportingV2 {
  __typename;
  bonus_cost_summary;
  casino_summary;
  global_spins_summary;
  iso_alpha2_country_code;
  path;
  player_activity_summary;
  player_ecology;
  poker_mtt_summary;
  poker_nlhe_summary;
  poker_plo_summary;
  poker_summary;
  referrer_agent_id;
  referrer_agent_username;
  share_summary;
  sports_summary;
  total_ggr_summary;
  uid;
  username;
}
class AgentPlayerReportingV2Page {
  __typename;
  /** array of reports for sub agents and players invited by agents */
  items;
  /** summary with summed up values of reports for all pages */
  summary;
  total_count;
}
class AgentPlayerReportingV2Summary {
  __typename;
  bonus_cost_summary;
  casino_summary;
  global_spins_summary;
  player_activity_summary;
  poker_mtt_summary;
  poker_nlhe_summary;
  poker_plo_summary;
  poker_summary;
  share_summary;
  sports_summary;
  total_ggr_summary;
}
class AgentPlayerReportingVn {
  __typename;
  active_player_number;
  casino_ggr;
  /**
   * referee contact info: mobile and email
   *
   * ### Policies: ###
   *
   * ** For all users: ** if auth token contains `full-player` or `full-player:read` contact info is visible, else it is masked
   */
  contact;
  insurance_tool;
  rakes;
  /** is referee player or subagent */
  referee_type;
  /** player id of agent */
  referrer_agent_id;
  referrer_agent_username;
  registered_player_number;
  revenue_share;
  /** is revenue generated directly during playing or as a subagent */
  revenue_share_type;
  /** player id of referee */
  uid;
}
class AgentPlayerReportingVnPage {
  __typename;
  /** array of reports for sub agents and players invited by vietnamese agents */
  items;
  /** summary with summed up values of reports for all pages */
  summary;
  total_count;
}
class AgentPlayerReportingVnSummary {
  __typename;
  casino_ggr;
  insurance_tool;
  rakes;
  revenue_share;
}
class AgentProfileFilter {
  /** if true filter only master agents */
  is_master_agent;
  referrer_agent_id;
  text;
}
class AgentRefereeRevenueReport {
  __typename;
  agent_uid;
  agent_username;
  casino_commissionable_amount;
  casino_costs;
  casino_ggr;
  casino_net_share;
  casino_ngr;
  casino_share_ratio_perc;
  commission_subtypes;
  global_spins_commissionable_amount;
  global_spins_costs;
  global_spins_ggr;
  global_spins_net_share;
  global_spins_ngr;
  global_spins_share_ratio_perc;
  iso_alpha2_country_code;
  poker_cash_plo_commissionable_amount;
  poker_cash_plo_costs;
  poker_cash_plo_ggr;
  poker_cash_plo_net_share;
  poker_cash_plo_ngr;
  poker_cash_plo_share_ratio_perc;
  poker_mtt_commissionable_amount;
  poker_mtt_costs;
  poker_mtt_ggr;
  poker_mtt_net_share;
  poker_mtt_ngr;
  poker_mtt_share_ratio_perc;
  poker_nlhe_sd_commissionable_amount;
  poker_nlhe_sd_costs;
  poker_nlhe_sd_ggr;
  poker_nlhe_sd_net_share;
  poker_nlhe_sd_ngr;
  poker_nlhe_sd_share_ratio_perc;
  row_id;
  sports_commissionable_amount;
  sports_costs;
  sports_ggr;
  sports_net_share;
  sports_ngr;
  sports_share_ratio_perc;
  total_net_share;
  week_start_date_ts;
}
class AgentRefereeRevenueReportFilter {
  daily_aggregation_range;
  is_downstream;
  row_id;
  text;
  week_start_date_ts;
}
class AgentRefereeRevenueReportPage {
  __typename;
  items;
  last_updated;
  total_count;
}
class AgentRevenueShareInput {
  casino_share;
  commission_subtypes;
  poker_cash;
  poker_cash_plo;
  poker_mtt;
  spins;
  sports;
}
class AgentRevenueShareTier {
  __typename;
  casino_revenue_share;
  generated_external_casino_ggr;
  generated_internal_casino_ggr;
  poker_revenue_share;
  revenue_shared;
}
class AgentRevenueShareWeeklyReport {
  __typename;
  adjusted_revenue_shared_total;
  carry_over_negative_balance;
  casino_ggr;
  external_casino_ggr;
  internal_casino_ggr;
  poker_ngr;
  referrer_id;
  referrer_psp_fees;
  referrer_username;
  revenue_shared_total;
  tiers;
  week_start_date_ts;
}
class AgentRevenueShareWeeklyReportFilter {
  text;
}
class AgentRevenueShareWeeklyReportPage {
  __typename;
  items;
  total_count;
}
class AggregatedFinanceSummariesFilterInput {
  aggregation_range;
  text;
}
class AggregatedFinanceSummariesPage {
  __typename;
  items;
  total_count;
}
class AggregatedFinanceSummary {
  __typename;
  bonus_ratio;
  created_at;
  /** total deposit attempts summary */
  deposit;
  end_at;
  generated_rake;
  ggr;
  lifetime_bonus;
  start_at;
  uid;
  /** total withdrawal attempts summary */
  withdrawal;
}
class AggregatedFinanceSummaryFilterInput {
  aggregation_range;
  uid;
}
class AggregatedFinanceSummaryInput {
  bonus_ratio;
  created_at;
  deposit;
  generated_rake;
  ggr;
  lifetime_bonus;
  uid;
  withdrawal;
}
var AmlLabel = /* @__PURE__ */ ((AmlLabel2) => {
  AmlLabel2["AccountReview"] = "AccountReview";
  AmlLabel2["ActivityReview"] = "ActivityReview";
  AmlLabel2["EddDeposit"] = "EddDeposit";
  AmlLabel2["EddGameplay"] = "EddGameplay";
  AmlLabel2["EddPep"] = "EddPep";
  AmlLabel2["EddWithdrawal"] = "EddWithdrawal";
  AmlLabel2["GameplayReview"] = "GameplayReview";
  AmlLabel2["VerifyPaymentMethod"] = "VerifyPaymentMethod";
  return AmlLabel2;
})(AmlLabel || {});
class Attachment {
  __typename;
  extension;
  filename;
  id;
  size;
  type;
  url;
}
class AttachmentInput {
  extension;
  filename;
  id;
  size;
  type;
  url;
}
class AutoWithdrawalRulesData {
  __typename;
  is_current_transaction_closed_loop;
  is_current_transaction_first_withdrawal;
  is_kyc_approved;
  is_security_case_opened;
  last_withdrawal_status;
  player_labels;
  total_player_locks;
  total_successful_withdrawals_count;
  total_successful_withdrawals_last_24h;
  total_successful_withdrawals_lt;
  transaction_amount;
  transaction_id;
  uid;
}
class BackpackItem {
  __typename;
  bonus_id;
  bonus_name;
  bonus_status;
  created_at;
  marketing_code;
  serial_number;
  source;
  tool_label;
  uid;
  used_at;
  value;
}
class BackpackItemInput {
  bonus_engine_code;
  bonus_id;
  bonus_name;
  bonus_status;
  created_at;
  marketing_code;
  mtt_id;
  serial_number;
  source;
  tool_label;
  trigger_by;
  trigger_by_uid;
  uid;
  used_at;
  value;
}
var BackpackItemLabel = /* @__PURE__ */ ((BackpackItemLabel2) => {
  BackpackItemLabel2["A93"] = "A93";
  BackpackItemLabel2["CompensationTicket"] = "CompensationTicket";
  BackpackItemLabel2["FreeMatch"] = "FreeMatch";
  BackpackItemLabel2["Gift"] = "Gift";
  BackpackItemLabel2["MttReward"] = "MTTReward";
  BackpackItemLabel2["PlayerBuy"] = "PlayerBuy";
  BackpackItemLabel2["PointRedeem"] = "PointRedeem";
  BackpackItemLabel2["RewardActivity"] = "RewardActivity";
  return BackpackItemLabel2;
})(BackpackItemLabel || {});
var BackpackItemSource = /* @__PURE__ */ ((BackpackItemSource2) => {
  BackpackItemSource2["BonusEngine"] = "Bonus_Engine";
  BackpackItemSource2["MttBackoffice"] = "MTT_Backoffice";
  return BackpackItemSource2;
})(BackpackItemSource || {});
var BackpackItemStatus = /* @__PURE__ */ ((BackpackItemStatus2) => {
  BackpackItemStatus2["Active"] = "Active";
  BackpackItemStatus2["Expired"] = "Expired";
  BackpackItemStatus2["Used"] = "Used";
  return BackpackItemStatus2;
})(BackpackItemStatus || {});
class BackpackItemsFilter {
  text;
}
class BackpackItemsPage {
  __typename;
  items;
  total_count;
}
var BettingRound = /* @__PURE__ */ ((BettingRound2) => {
  BettingRound2["Flop"] = "Flop";
  BettingRound2["None"] = "None";
  BettingRound2["Preflop"] = "Preflop";
  BettingRound2["River"] = "River";
  BettingRound2["ShowDown"] = "ShowDown";
  BettingRound2["Turn"] = "Turn";
  return BettingRound2;
})(BettingRound || {});
class BlackListItem {
  __typename;
  key;
  type;
}
class BlackListItemInput {
  key;
  type;
}
var BlackListItemType = /* @__PURE__ */ ((BlackListItemType2) => {
  BlackListItemType2["Device"] = "DEVICE";
  BlackListItemType2["Ip"] = "IP";
  return BlackListItemType2;
})(BlackListItemType || {});
class BlacklistIp {
  __typename;
  ip;
}
class BlacklistIpPage {
  __typename;
  items;
  total_count;
}
class BoUser {
  __typename;
  attributes;
  email;
  enabled;
  first_name;
  groups;
  id;
  last_name;
  username;
}
class BoUserAttributes {
  __typename;
  player_id;
}
class BoUserAttributesInput {
  player_id;
}
class BoUserCredentials {
  __typename;
  temporary;
  type;
  value;
}
class BoUserCredentialsInput {
  temporary;
  type;
  value;
}
class BoUserFilter {
  aal_group_ids;
  group_ids;
  role_group_ids;
  text;
  user_id;
}
class BoUserInput {
  attributes;
  credentials;
  email;
  first_name;
  groups;
  last_name;
  username;
}
class BoUserPage {
  __typename;
  items;
  total;
}
class BoUserSettings {
  __typename;
  /**
   * Daily (UTC 00:00 - UTC 24:00) credit limit for this BoUser
   *
   * different value based on auth token containing `credit-limit-1:create`, `credit-limit-2:create` or `credit-limit-3:create`
   */
  personal_daily_credit_limit;
  /** Credit amount BoUser can use, based on total_daily_limit, personal_daily_limit and credits made during this day (UTC 00:00 - UTC 24:00) */
  remaining_credit_amount;
  /** Daily (UTC 00:00 - UTC 24:00) credit limit for all BoUsers, same value for all */
  total_daily_credit_limit;
}
class BonusCasino {
  __typename;
  aggregators;
  game_codes;
  source_types;
  supplier_codes;
}
class BonusCasinoInput {
  /** List of casino aggregators. Only `External` games have aggregator. Examples: bragg */
  aggregators;
  /**
   * List of casino game codes
   *
   * External game examples: ARC_ARM, ARC_DEA, ASL_EGM_EU, ASL_ENM_EU_94
   *
   * Internal game examples: POKERFLIP, POKERMASTER
   */
  game_codes;
  source_types;
  /** List of casino supplier codes. Only `External` games have supplier. Examples: EVOL, GAM, BBR */
  supplier_codes;
}
var BonusCasinoSourceType = /* @__PURE__ */ ((BonusCasinoSourceType2) => {
  BonusCasinoSourceType2["External"] = "External";
  BonusCasinoSourceType2["Internal"] = "Internal";
  return BonusCasinoSourceType2;
})(BonusCasinoSourceType || {});
class BonusCodeDetails {
  __typename;
  bonus_id;
  bonus_name;
  bonus_status;
  bonus_to_credit;
  create_time;
  created_by;
  credit_type;
  description;
  end_time;
  last_update;
  marketing_codes;
  meta;
  platform;
  release_mechanism;
  release_metric;
  release_ratio_type;
  start_time;
  threshold;
  total_paid_out_amount;
}
class BonusCodeFilterInput {
  bonus_status;
  create_time;
  credit_type;
  text;
}
class BonusCodeHistory {
  __typename;
  bonus_id;
  created_at;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** if auth token contains `full-player` or `full-player:read` email is visible, else it is masked
   */
  email;
  id;
  iso_alpha2_country_code;
  transaction_amount;
  /** initiator type for triggering a bonus */
  trigger_by;
  /**
   * initiator unique identifier for triggering a bonus
   * ('CIO' when initated by CIO, uid when initiated from back office)
   */
  trigger_by_uid;
  type;
  uid;
  unrealized_amount;
  username;
}
class BonusCodeHistoryFilterInput {
  created_at;
  text;
  type;
}
class BonusCodeHistoryInput {
  bonus_id;
  created_at;
  email;
  id;
  iso_alpha2_country_code;
  transaction_amount;
  trigger_by;
  /**
   * initiator unique identifier for triggering a bonus
   * ('CIO' when initiated by CIO, uid when initiated from back office)
   */
  trigger_by_uid;
  type;
  uid;
  unrealized_amount;
  username;
}
class BonusCodeHistoryPage {
  __typename;
  items;
  total_count;
}
class BonusCodeInput {
  bonus_name;
  bonus_status;
  bonus_to_credit;
  create_time;
  created_by;
  credit_type;
  description;
  end_time;
  meta;
  platform;
  release_mechanism;
  release_metric;
  release_ratio_type;
  start_time;
  threshold;
}
class BonusCodePage {
  __typename;
  items;
  total_count;
}
class BonusCodeUpsert {
  bonus_id;
  bonus_name;
  bonus_status;
  bonus_to_credit;
  business_pool;
  create_time;
  created_by;
  credit_type;
  description;
  end_time;
  last_update;
  marketing_codes;
  meta;
  platform;
  release_mechanism;
  release_metric;
  release_ratio_type;
  start_time;
  threshold;
  total_paid_out_amount;
  ts;
}
class BonusCostSummary {
  __typename;
  cash_realized_bonus;
  cost_ftd_bonus_pro;
  cost_psp_fee_pro;
  cost_tournament_overlay;
  cost_tournament_overlay_excl_freeroll;
  mtt_ticket_bonus;
  poker_bonus;
  psp_fee;
}
var BonusCreditType = /* @__PURE__ */ ((BonusCreditType2) => {
  BonusCreditType2["CashBonus"] = "CASH_BONUS";
  BonusCreditType2["CasinoCoin"] = "CASINO_COIN";
  BonusCreditType2["MttToken"] = "MTT_TOKEN";
  return BonusCreditType2;
})(BonusCreditType || {});
class BonusMeta {
  __typename;
  bonus_value_param;
  casino_excluded;
  casino_included;
  expire_period;
  max_bonus_get;
  metric_amount;
  metric_qualify;
  min_deposit;
  overall_max_bonus_get;
  rake_amount;
  rake_qualify;
  release_ratios;
  show_max_bonus_in_total;
  ticket_serial;
  time_range_by_date;
  total_max_bonus_get;
  unrealized_expire_period;
}
class BonusMetaInput {
  bonus_value_param;
  /**
   * Configuration for casino games for which bonus should not be applied.
   *
   * If any field is passed in `casino_excluded`, the same field must not be passed in `casino_included`
   */
  casino_excluded;
  /**
   * Configuration for casino games for which bonus should be applied.
   *
   * If any field is passed in `casino_included`, the same field must not be passed in `casino_excluded`
   */
  casino_included;
  expire_period;
  max_bonus_get;
  metric_amount;
  metric_qualify;
  min_deposit;
  overall_max_bonus_get;
  rake_amount;
  rake_qualify;
  release_ratios;
  show_max_bonus_in_total;
  ticket_serial;
  time_range_by_date;
  total_max_bonus_get;
  unrealized_expire_period;
}
var BonusReleaseMechanism = /* @__PURE__ */ ((BonusReleaseMechanism2) => {
  BonusReleaseMechanism2["AmountPerReleaseMetricAmount"] = "AMOUNT_PER_RELEASE_METRIC_AMOUNT";
  BonusReleaseMechanism2["Immediate"] = "IMMEDIATE";
  return BonusReleaseMechanism2;
})(BonusReleaseMechanism || {});
var BonusReleaseMetric = /* @__PURE__ */ ((BonusReleaseMetric2) => {
  BonusReleaseMetric2["None"] = "NONE";
  BonusReleaseMetric2["RakeGenerated"] = "RAKE_GENERATED";
  BonusReleaseMetric2["WagerGenerated"] = "WAGER_GENERATED";
  return BonusReleaseMetric2;
})(BonusReleaseMetric || {});
class BonusReleaseRatio {
  __typename;
  category;
  layer_metric_amount;
  layer_metric_qualify;
  level;
}
class BonusReleaseRatioInput {
  category;
  layer_metric_amount;
  layer_metric_qualify;
  level;
}
var BonusReleaseRatioType = /* @__PURE__ */ ((BonusReleaseRatioType2) => {
  BonusReleaseRatioType2["Fixed"] = "FIXED";
  BonusReleaseRatioType2["Layering"] = "LAYERING";
  return BonusReleaseRatioType2;
})(BonusReleaseRatioType || {});
var BonusStatus = /* @__PURE__ */ ((BonusStatus2) => {
  BonusStatus2["Active"] = "ACTIVE";
  BonusStatus2["Inactive"] = "INACTIVE";
  return BonusStatus2;
})(BonusStatus || {});
class BonusSummary {
  __typename;
  cash_realized_bonus;
  casino_bonus;
  cost_global_spins_tickets;
  mtt_ticket_bonus;
  poker_bonus;
  realized_bonus_total;
  unrealized_bonus_total;
}
var BonusToCredit = /* @__PURE__ */ ((BonusToCredit2) => {
  BonusToCredit2["Amount"] = "AMOUNT";
  BonusToCredit2["PercentOfTriggerAmount"] = "PERCENT_OF_TRIGGER_AMOUNT";
  return BonusToCredit2;
})(BonusToCredit || {});
var BonusType = /* @__PURE__ */ ((BonusType2) => {
  BonusType2["Deposit"] = "Deposit";
  BonusType2["Register"] = "Register";
  BonusType2["Team"] = "Team";
  return BonusType2;
})(BonusType || {});
var BotDetectionActionType = /* @__PURE__ */ ((BotDetectionActionType2) => {
  BotDetectionActionType2["BotDetectionActionTypeAdded"] = "BOT_DETECTION_ACTION_TYPE_ADDED";
  BotDetectionActionType2["BotDetectionActionTypeRemoved"] = "BOT_DETECTION_ACTION_TYPE_REMOVED";
  return BotDetectionActionType2;
})(BotDetectionActionType || {});
var BotDetectionPlayersGroup = /* @__PURE__ */ ((BotDetectionPlayersGroup2) => {
  BotDetectionPlayersGroup2["BotDetectionBotPlayer"] = "BOT_DETECTION_BOT_PLAYER";
  BotDetectionPlayersGroup2["BotDetectionEvidence"] = "BOT_DETECTION_EVIDENCE";
  BotDetectionPlayersGroup2["BotDetectionUndefined"] = "BOT_DETECTION_UNDEFINED";
  return BotDetectionPlayersGroup2;
})(BotDetectionPlayersGroup || {});
class BotGroup {
  __typename;
  count;
  created_at_ts;
  group_id;
  pfr_average;
  recently_active;
  total_funds;
  uids;
  vpip_average;
}
class BotGroupFilter {
  created_at_ts;
  text;
}
class BotGroupInput {
  count;
  created_at_ts;
  group_id;
  pfr_average;
  recently_active;
  total_funds;
  uids;
  vpip_average;
}
class BotGroupPage {
  __typename;
  items;
  total_count;
}
var Brand = /* @__PURE__ */ ((Brand2) => {
  Brand2["Akspoker"] = "AKSPOKER";
  Brand2["Nexapoker"] = "NEXAPOKER";
  Brand2["Unknown"] = "UNKNOWN";
  Brand2["Wptg"] = "WPTG";
  Brand2["Wptgo"] = "WPTGO";
  Brand2["Wptgpuke"] = "WPTGPUKE";
  return Brand2;
})(Brand || {});
class BulkItem {
  __typename;
  id;
  item_id;
  message;
  status;
}
class BulkItemDataInput {
  account_lock;
  bonus;
  /** input for lockCasinoBulkOperation */
  casino_lock;
  deposit_lock;
  /** input for initPaymentKYCBulkOperation and initSecurityKYCBulkOperation */
  kyc_init;
  /** input for updateKYCBulkOperation */
  kyc_status;
  lobby_lock;
  /** input for `addManualCreditCases` */
  manual_credit_case;
  /** input for `updateManualCreditCaseStatuses` */
  manual_credit_case_status;
  /** @deprecated Use `p2p_settings_v2` */
  p2p_lock;
  /** @deprecated Use `p2p_settings_v2` */
  p2p_settings;
  p2p_settings_v2;
  /** input for `addP2PTransferBulkOperation` */
  p2p_transfer;
  /** input for lockSportsbookBulkOperation */
  sportsbook_lock;
  transaction;
  user_assign;
  user_label_add;
  user_label_delete;
  white_list;
  withdrawal_lock;
}
class BulkItemInput {
  /** payload of bulk operation item */
  data;
  /** unique id of item */
  id;
}
var BulkItemStatus = /* @__PURE__ */ ((BulkItemStatus2) => {
  BulkItemStatus2["Failed"] = "Failed";
  BulkItemStatus2["InProgress"] = "InProgress";
  BulkItemStatus2["PartiallySuccessful"] = "PartiallySuccessful";
  BulkItemStatus2["Pending"] = "Pending";
  BulkItemStatus2["Successful"] = "Successful";
  BulkItemStatus2["TimedOut"] = "TimedOut";
  return BulkItemStatus2;
})(BulkItemStatus || {});
class BulkMutationInput {
  /** list of items with payload */
  items;
  /** number of retries for single items */
  retries;
  /** timeout for single item in seconds */
  timeout;
}
class BulkMutationResponse {
  __typename;
  id;
}
class BulkOperationFilterInput {
  id;
}
class BulkOperationResult {
  __typename;
  end_at;
  entity_type;
  id;
  items;
  retries;
  start_at;
  status;
  timeout;
}
class BulkOperationResultFilter {
  text;
}
class BulkOperationResultPage {
  __typename;
  items;
  total_count;
}
var BulkOperationStatus = /* @__PURE__ */ ((BulkOperationStatus2) => {
  BulkOperationStatus2["Completed"] = "Completed";
  BulkOperationStatus2["InProgress"] = "InProgress";
  BulkOperationStatus2["Pending"] = "Pending";
  return BulkOperationStatus2;
})(BulkOperationStatus || {});
class BulkP2PPlayerSettingsInput {
  p2p_settings;
  uid;
}
class BulkP2PPlayerSettingsV2Input {
  p2p_settings;
  uid;
}
class CardItem {
  __typename;
  number;
  suit;
}
class CardItemInput {
  number;
  suit;
}
var CardNumber = /* @__PURE__ */ ((CardNumber2) => {
  CardNumber2["Card_2"] = "Card_2";
  CardNumber2["Card_3"] = "Card_3";
  CardNumber2["Card_4"] = "Card_4";
  CardNumber2["Card_5"] = "Card_5";
  CardNumber2["Card_6"] = "Card_6";
  CardNumber2["Card_7"] = "Card_7";
  CardNumber2["Card_8"] = "Card_8";
  CardNumber2["Card_9"] = "Card_9";
  CardNumber2["Card_10"] = "Card_10";
  CardNumber2["CardA"] = "Card_A";
  CardNumber2["CardJ"] = "Card_J";
  CardNumber2["CardK"] = "Card_K";
  CardNumber2["CardQ"] = "Card_Q";
  return CardNumber2;
})(CardNumber || {});
var CardSuite = /* @__PURE__ */ ((CardSuite2) => {
  CardSuite2["Club"] = "Club";
  CardSuite2["Diamond"] = "Diamond";
  CardSuite2["Heart"] = "Heart";
  CardSuite2["Spade"] = "Spade";
  return CardSuite2;
})(CardSuite || {});
class CasinoError {
  __typename;
  code;
  values;
}
var CasinoProviderName = /* @__PURE__ */ ((CasinoProviderName2) => {
  CasinoProviderName2["Oryx"] = "Oryx";
  return CasinoProviderName2;
})(CasinoProviderName || {});
class CasinoResponse {
  __typename;
  error;
  reference_id;
  success;
}
class CasinoSummary {
  __typename;
  casino_bonus;
  casino_ggr;
  casino_ngr;
  casino_share;
  casino_wager;
  external_casino_ggr;
  internal_casino_ggr;
}
class CasinoTriggerInput {
  casino_code;
  casino_provider_name;
  currency;
  reference_id;
  uid;
}
var Channel = /* @__PURE__ */ ((Channel2) => {
  Channel2["None"] = "NONE";
  Channel2["Official"] = "OFFICIAL";
  Channel2["P2P"] = "P2P";
  return Channel2;
})(Channel || {});
class Club {
  __typename;
  club_id;
  club_name;
}
class ClubsFilter {
  text;
}
class ClubsPage {
  __typename;
  items;
  total_count;
}
var CommentTargetType = /* @__PURE__ */ ((CommentTargetType2) => {
  CommentTargetType2["BotGroup"] = "BOT_GROUP";
  CommentTargetType2["Player"] = "PLAYER";
  return CommentTargetType2;
})(CommentTargetType || {});
var CommissionSubTypes = /* @__PURE__ */ ((CommissionSubTypes2) => {
  CommissionSubTypes2["CasinoGgr"] = "casino_ggr";
  CommissionSubTypes2["CasinoGgrAfterExternalCosts"] = "casino_ggr_after_external_costs";
  CommissionSubTypes2["CasinoWager"] = "casino_wager";
  CommissionSubTypes2["GlobalSpinsExpectedEggr"] = "global_spins_expected_eggr";
  CommissionSubTypes2["PokerCashPloGgr"] = "poker_cash_plo_ggr";
  CommissionSubTypes2["PokerGgrAfterProPenaltiesAfterEcology"] = "poker_ggr_after_pro_penalties_after_ecology";
  CommissionSubTypes2["PokerGgrAfterProPenaltiesAfterEcologyNoInsurance"] = "poker_ggr_after_pro_penalties_after_ecology_no_insurance";
  CommissionSubTypes2["PokerMttGgr"] = "poker_mtt_ggr";
  CommissionSubTypes2["PokerNgrExcPloAfterProPenaltiesAfterEcology"] = "poker_ngr_exc_plo_after_pro_penalties_after_ecology";
  CommissionSubTypes2["SportsGgr"] = "sports_ggr";
  CommissionSubTypes2["SportsWagerForSettledBets"] = "sports_wager_for_settled_bets";
  return CommissionSubTypes2;
})(CommissionSubTypes || {});
var CommissionSubTypesHistorical = /* @__PURE__ */ ((CommissionSubTypesHistorical2) => {
  CommissionSubTypesHistorical2["Mixed"] = "Mixed";
  CommissionSubTypesHistorical2["CasinoGgr"] = "casino_ggr";
  CommissionSubTypesHistorical2["CasinoGgrAfterExternalCosts"] = "casino_ggr_after_external_costs";
  CommissionSubTypesHistorical2["CasinoWager"] = "casino_wager";
  CommissionSubTypesHistorical2["GlobalSpinsExpectedEggr"] = "global_spins_expected_eggr";
  CommissionSubTypesHistorical2["PokerCashPloGgr"] = "poker_cash_plo_ggr";
  CommissionSubTypesHistorical2["PokerGgrAfterProPenaltiesAfterEcology"] = "poker_ggr_after_pro_penalties_after_ecology";
  CommissionSubTypesHistorical2["PokerGgrAfterProPenaltiesAfterEcologyNoInsurance"] = "poker_ggr_after_pro_penalties_after_ecology_no_insurance";
  CommissionSubTypesHistorical2["PokerMttGgr"] = "poker_mtt_ggr";
  CommissionSubTypesHistorical2["PokerNgrExcPloAfterProPenaltiesAfterEcology"] = "poker_ngr_exc_plo_after_pro_penalties_after_ecology";
  CommissionSubTypesHistorical2["SportsGgr"] = "sports_ggr";
  CommissionSubTypesHistorical2["SportsWagerForSettledBets"] = "sports_wager_for_settled_bets";
  return CommissionSubTypesHistorical2;
})(CommissionSubTypesHistorical || {});
class ComplianceResultInput {
  matched;
  pep;
  sanction;
}
class CountryInfo {
  __typename;
  iso_alpha2_code;
  name;
}
class CountryInfoInput {
  iso_alpha2_code;
  name;
}
class CountryLevelReport {
  __typename;
  casino_ggr;
  country;
  daily_active_users;
  date_ts;
  deposit_count;
  deposit_users;
  first_deposit_amount;
  first_time_deposit_users;
  global_spins_ggr;
  net_deposit;
  new_users;
  payout_amount;
  poker_cash_ggr;
  poker_mtt_ggr;
  promotional_spend;
  retained_deposit_amount;
  retained_deposit_users;
  sports_ggr;
  total_bet_amount;
  total_deposit_amount;
  total_ggr;
  total_hands;
  total_mtt_entries;
  total_withdrawal_amount;
  withdrawal_count;
  withdrawal_users;
}
class CountryLevelReportPage {
  __typename;
  /** array of reports for sub agents and players invited by agents */
  items;
  /** summary with summed up values of reports for all pages */
  summary;
  total_count;
}
class CountryLevelReportSummary {
  __typename;
  casino_ggr;
  daily_active_users;
  deposit_count;
  deposit_users;
  first_deposit_amount;
  first_time_deposit_users;
  global_spins_ggr;
  net_deposit;
  new_users;
  payout_amount;
  poker_cash_ggr;
  poker_mtt_ggr;
  promotional_spend;
  retained_deposit_amount;
  retained_deposit_users;
  sports_ggr;
  total_bet_amount;
  total_deposit_amount;
  total_ggr;
  total_hands;
  total_mtt_entries;
  total_withdrawal_amount;
  withdrawal_count;
  withdrawal_users;
}
class CountryLevelReportingFilter {
  country;
  date_ts;
}
class CreateRepaymentLogInput {
  from_agent_uid;
  master_agent_uid;
  repayment_amount;
  repayment_date;
}
class CreateTurnoverConfig {
  countries;
  license;
  scope_type;
  turnover_rate;
}
class DashboardUrl {
  __typename;
  expire_at;
  url;
}
class DateRange {
  from;
  to;
}
var DebtAdjustmentType = /* @__PURE__ */ ((DebtAdjustmentType2) => {
  DebtAdjustmentType2["Add"] = "Add";
  DebtAdjustmentType2["Deduct"] = "Deduct";
  return DebtAdjustmentType2;
})(DebtAdjustmentType || {});
class DebtResponsibleMasterAgent {
  __typename;
  agent_id;
  aggregated_downline_debt;
  created_at;
  created_by;
  downline_agents_count;
  username;
}
class DebtResponsibleMasterAgents {
  __typename;
  agent_uid;
  agent_username;
  created_at;
  created_by;
  downline_agents_count;
  total_debt_before_payment;
}
class DebtResponsibleMasterAgentsFilter {
  text;
}
class DebtResponsibleMasterAgentsPage {
  __typename;
  items;
  total_count;
}
class DebtTransferLog {
  __typename;
  agent_uid;
  agent_username;
  created_at;
  log_id;
  master_agent_uid;
  master_agent_username;
  transfer_date;
  transferred_amount;
}
class DebtTransferLogsFilter {
  text;
  transfer_date;
}
class DebtTransferLogsPage {
  __typename;
  items;
  last_updated;
  total_count;
}
class DeductionSummary {
  __typename;
  casino_provider_fee;
  ngr_cost;
  psp_fee;
  total;
}
class DeleteP2PGlobalSettingsInput {
  country;
  is_agent;
  kyc_status;
  license_type;
}
class DeleteP2PGlobalSettingsV2Input {
  country;
  kyc_status;
  license_type;
  p2p_sender;
}
class DeleteTurnoverConfig {
  id;
}
class DeleteUserLabelInput {
  label_id;
  uid;
}
class Device {
  __typename;
  agent;
  mac_address;
  model;
  name;
  operating_system;
  uuid;
}
class DeviceInput {
  agent;
  mac_address;
  model;
  name;
  operating_system;
  uuid;
}
class EditRepaymentLogInput {
  from_agent_uid;
  master_agent_uid;
  repayment_amount;
  repayment_date;
  repayment_id;
}
var EmbeddedDashboardType = /* @__PURE__ */ ((EmbeddedDashboardType2) => {
  EmbeddedDashboardType2["GlobalAgentLevelReport"] = "GlobalAgentLevelReport";
  EmbeddedDashboardType2["GlobalPlayerLevelReport"] = "GlobalPlayerLevelReport";
  EmbeddedDashboardType2["GlobalTransferReport"] = "GlobalTransferReport";
  return EmbeddedDashboardType2;
})(EmbeddedDashboardType || {});
class Entity {
  __typename;
  id;
  parent;
  type;
}
var EntityFilterType = /* @__PURE__ */ ((EntityFilterType2) => {
  EntityFilterType2["AllRecords"] = "AllRecords";
  EntityFilterType2["Specific"] = "Specific";
  return EntityFilterType2;
})(EntityFilterType || {});
class EntityInput {
  id;
  parent;
  type;
}
var EntityRelationType = /* @__PURE__ */ ((EntityRelationType2) => {
  EntityRelationType2["Global"] = "Global";
  EntityRelationType2["Record"] = "Record";
  return EntityRelationType2;
})(EntityRelationType || {});
var EntityType = /* @__PURE__ */ ((EntityType2) => {
  EntityType2["Bonus"] = "Bonus";
  EntityType2["BotGroup"] = "BotGroup";
  EntityType2["Deposit"] = "Deposit";
  EntityType2["KycAssign"] = "KYCAssign";
  EntityType2["KycCase"] = "KYCCase";
  EntityType2["P2PSettings"] = "P2PSettings";
  EntityType2["Player"] = "Player";
  EntityType2["Transaction"] = "Transaction";
  EntityType2["TransactionAssign"] = "TransactionAssign";
  EntityType2["Withdrawal"] = "Withdrawal";
  return EntityType2;
})(EntityType || {});
var EventInitiator = /* @__PURE__ */ ((EventInitiator2) => {
  EventInitiator2["Bo"] = "BO";
  EventInitiator2["Cio"] = "CIO";
  EventInitiator2["None"] = "None";
  EventInitiator2["Player"] = "Player";
  EventInitiator2["Service"] = "Service";
  return EventInitiator2;
})(EventInitiator || {});
class EventLogFilter {
  entity;
  initiator;
  side_effect;
  text;
  type;
}
class EventLogRecord {
  __typename;
  client_id;
  entity;
  entity_relation_type;
  event_description;
  event_name;
  id;
  new_value;
  prev_value;
  side_effect;
  trigger_at;
  trigger_by;
  trigger_by_id;
}
class EventLogRecordInput {
  action;
  entity;
  event_description;
  event_name;
  id;
  new_value;
  prev_value;
  trigger_at;
  trigger_by_id;
}
class EventLogRecordPage {
  __typename;
  items;
  total_count;
}
class FailedOrder {
  __typename;
  amount;
  category;
  error_code;
  order_id;
  status;
  timestamp;
  uid;
  username;
}
var FailedOrderCategory = /* @__PURE__ */ ((FailedOrderCategory2) => {
  FailedOrderCategory2["Casino"] = "Casino";
  return FailedOrderCategory2;
})(FailedOrderCategory || {});
class FailedOrderFilter {
  category;
  order_id;
  status;
  timestamp;
  uid;
}
class FailedOrderPage {
  __typename;
  items;
  total_count;
}
var FailedOrderStatus = /* @__PURE__ */ ((FailedOrderStatus2) => {
  FailedOrderStatus2["Deleted"] = "Deleted";
  FailedOrderStatus2["Failed"] = "Failed";
  FailedOrderStatus2["InProgress"] = "InProgress";
  FailedOrderStatus2["Successful"] = "Successful";
  return FailedOrderStatus2;
})(FailedOrderStatus || {});
class FailureTransactionInput {
  amount;
  change_source;
  currency;
  error_code;
  error_json;
  failed_order_type;
  failure_ts;
  order_id;
  order_status;
  original_amount;
  original_currency;
  product;
  retries;
  type;
  uid;
}
class FeatureAccessLockInput {
  /** status of the feature access */
  feature_status;
  /** should be added to event log */
  note;
  /** should be added to event log */
  reason;
  /** unique id of user */
  uid;
}
var FeatureAccessStatus = /* @__PURE__ */ ((FeatureAccessStatus2) => {
  FeatureAccessStatus2["Locked"] = "LOCKED";
  FeatureAccessStatus2["Unlocked"] = "UNLOCKED";
  return FeatureAccessStatus2;
})(FeatureAccessStatus || {});
class FlashCampaign {
  __typename;
  campaign_id;
  created_at;
  end_date;
  license_list;
  name;
  periodicity;
  points_multiplier;
  /** `prize_pools` will be retrieved only when filter contains `campaign_id` */
  prize_pools;
  start_date;
  status;
  total_prize_usd_per_day_all_pools;
  updated_at;
  updated_by;
}
class FlashCampaignFilter {
  /**
   * return campaign if its'
   *
   * `start_date` ≤ `campaign_date.to` AND `end_date` ≥ `campaign_date.from`
   */
  campaign_date;
  campaign_id;
  licenses;
  statuses;
  /** Text filter should support filtering by `name` */
  text;
}
class FlashCampaignInput {
  end_date;
  license_list;
  name;
  periodicity;
  points_multiplier;
  prize_pools;
  start_date;
  total_prize_usd_per_day_all_pools;
}
class FlashCampaignPage {
  __typename;
  items;
  total;
}
var FlashCampaignPeriodicity = /* @__PURE__ */ ((FlashCampaignPeriodicity2) => {
  FlashCampaignPeriodicity2["Daily"] = "Daily";
  return FlashCampaignPeriodicity2;
})(FlashCampaignPeriodicity || {});
var FlashCampaignStatus = /* @__PURE__ */ ((FlashCampaignStatus2) => {
  FlashCampaignStatus2["Active"] = "Active";
  FlashCampaignStatus2["Archived"] = "Archived";
  FlashCampaignStatus2["Completed"] = "Completed";
  FlashCampaignStatus2["Draft"] = "Draft";
  FlashCampaignStatus2["Paused"] = "Paused";
  return FlashCampaignStatus2;
})(FlashCampaignStatus || {});
class FriendGroup {
  __typename;
  group_id;
  group_name;
  players;
}
class FriendGroupFilter {
  text;
}
class FriendGroupInput {
  group_id;
  group_name;
  players;
}
class FriendGroupPage {
  __typename;
  items;
  total_count;
}
var FriendsGroupUsersActionType = /* @__PURE__ */ ((FriendsGroupUsersActionType2) => {
  FriendsGroupUsersActionType2["Added"] = "ADDED";
  FriendsGroupUsersActionType2["Removed"] = "REMOVED";
  return FriendsGroupUsersActionType2;
})(FriendsGroupUsersActionType || {});
class Ggr {
  __typename;
  casino_connector;
  casino_poker_flips;
  mtt_service_fee;
  poker_features_purchase;
  poker_guess_hand;
  poker_insurance;
  poker_rake;
}
class GgrInput {
  casino_connector;
  casino_poker_flips;
  mtt_service_fee;
  poker_features_purchase;
  poker_guess_hand;
  poker_insurance;
  poker_rake;
}
class GgrLifetime {
  __typename;
  /** casino GGR */
  casino;
  /** poker GGR rake + fee */
  poker;
  /** sports GGR */
  sports;
}
class GgrSummary {
  __typename;
  cash_ggr;
  casino_ggr;
  casino_share;
  external_casino_bet_amount;
  external_casino_ggr;
  global_spin_ggr;
  internal_casino_bet_amount;
  internal_casino_ggr;
  mtt_ggr;
  mtt_total_buyin;
  plo_ggr_high_stake;
  plo_ggr_low_stake;
  plo_ggr_medium_stake;
  plo_ggr_micro_stake;
  plo_ggr_total;
  plo_ggr_unknown_stake;
  poker_addons;
  poker_ggr;
  poker_mtt_fees;
  poker_rake;
  poker_share;
  total;
  total_share;
}
class GameHistoryFilter {
  big_blind_size;
  game_type;
  limit_size;
  player_action;
  pot_size;
  started_at;
  text;
}
var GameMode = /* @__PURE__ */ ((GameMode2) => {
  GameMode2["Match"] = "MATCH";
  GameMode2["None"] = "NONE";
  GameMode2["Normal"] = "NORMAL";
  GameMode2["Other"] = "OTHER";
  GameMode2["Short"] = "SHORT";
  return GameMode2;
})(GameMode || {});
class GameTable {
  __typename;
  game_mode;
  game_type;
  limit;
}
class GameTableInput {
  game_mode;
  game_type;
  limit;
}
var GameType = /* @__PURE__ */ ((GameType2) => {
  GameType2["AofServer"] = "AofServer";
  GameType2["BetServer"] = "BetServer";
  GameType2["BlMtt"] = "BlMtt";
  GameType2["CowBoy"] = "CowBoy";
  GameType2["DataServer"] = "DataServer";
  GameType2["GameIdDummy"] = "GameId_Dummy";
  GameType2["HumanBoy"] = "HumanBoy";
  GameType2["Jackfruit"] = "Jackfruit";
  GameType2["PokerMaster"] = "PokerMaster";
  GameType2["StarSeat"] = "StarSeat";
  GameType2["Texas"] = "Texas";
  GameType2["VideoCowboy"] = "VideoCowboy";
  GameType2["World"] = "World";
  GameType2["ZoomTexas"] = "ZoomTexas";
  GameType2["ZoomTexasMax"] = "ZoomTexasMax";
  return GameType2;
})(GameType || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["Female"] = "FEMALE";
  Gender2["Male"] = "MALE";
  Gender2["Undefined"] = "UNDEFINED";
  return Gender2;
})(Gender || {});
class GeoCheck {
  __typename;
  check_id;
  connection_type;
  correlation_id;
  current_balance;
  device;
  error_codes;
  event_source;
  id;
  ip;
  ip_quality_score;
  isp;
  language;
  location;
  logged_at_ts;
  login_status;
  login_type;
  reason_categories;
  recaptcha_reasons;
  recaptcha_score;
  session_id;
  status;
  uid;
  username;
  vpn;
}
var GeoCheckEventSource = /* @__PURE__ */ ((GeoCheckEventSource2) => {
  GeoCheckEventSource2["Geocomply"] = "Geocomply";
  GeoCheckEventSource2["Login"] = "Login";
  return GeoCheckEventSource2;
})(GeoCheckEventSource || {});
class GeoCheckFilter {
  logged_at_ts;
  text;
}
class GeoCheckInput {
  check_id;
  connection_type;
  correlation_id;
  current_balance;
  device;
  error_codes;
  event_source;
  id;
  ip;
  ip_quality_score;
  isp;
  language;
  location;
  logged_at_ts;
  login_status;
  login_type;
  reason_categories;
  recaptcha_reasons;
  recaptcha_score;
  session_id;
  status;
  uid;
  username;
  vpn;
}
class GeoCheckPage {
  __typename;
  items;
  total_count;
}
var GeoCheckStatus = /* @__PURE__ */ ((GeoCheckStatus2) => {
  GeoCheckStatus2["Failed"] = "Failed";
  GeoCheckStatus2["Success"] = "Success";
  return GeoCheckStatus2;
})(GeoCheckStatus || {});
class GeoCheckSummary {
  __typename;
  fail_count;
  reason_categories;
  status;
  uid;
}
class GeoCheckSummaryInput {
  reason_categories;
  status;
  uid;
}
class GlobalSearchFilter {
  source;
  text;
}
class GlobalSearchRecord {
  __typename;
  key;
  meta;
  source;
}
var GlobalSearchSource = /* @__PURE__ */ ((GlobalSearchSource2) => {
  GlobalSearchSource2["PaymentMethod"] = "PaymentMethod";
  return GlobalSearchSource2;
})(GlobalSearchSource || {});
class GlobalSpinsSummary {
  __typename;
  cost_global_spins_tickets;
  global_spins_expected_ggr;
}
class Group {
  __typename;
  id;
  name;
}
class GroupInput {
  id;
}
class GroupPage {
  __typename;
  items;
  total;
}
class InitKycInput {
  /** list of reasons for initiating KYC case; optional for backward compatibility */
  reason_codes;
  uid;
}
class IpBlacklistFilterInput {
  ip;
}
var IsPro = /* @__PURE__ */ ((IsPro2) => {
  IsPro2["Mixed"] = "Mixed";
  IsPro2["NonPro"] = "NonPro";
  IsPro2["Pro"] = "Pro";
  return IsPro2;
})(IsPro || {});
var JumioDocumentSubType = /* @__PURE__ */ ((JumioDocumentSubType2) => {
  JumioDocumentSubType2["ConsularId"] = "CONSULAR_ID";
  JumioDocumentSubType2["ElectoralId"] = "ELECTORAL_ID";
  JumioDocumentSubType2["EPassport"] = "E_PASSPORT";
  JumioDocumentSubType2["HealthId"] = "HEALTH_ID";
  JumioDocumentSubType2["LearningDrivingLicense"] = "LEARNING_DRIVING_LICENSE";
  JumioDocumentSubType2["MilitaryId"] = "MILITARY_ID";
  JumioDocumentSubType2["NationalId"] = "NATIONAL_ID";
  JumioDocumentSubType2["OtherId"] = "OTHER_ID";
  JumioDocumentSubType2["PassportCardId"] = "PASSPORT_CARD_ID";
  JumioDocumentSubType2["PublicSafetyId"] = "PUBLIC_SAFETY_ID";
  JumioDocumentSubType2["RegularDrivingLicense"] = "REGULAR_DRIVING_LICENSE";
  JumioDocumentSubType2["ResidentPermitId"] = "RESIDENT_PERMIT_ID";
  JumioDocumentSubType2["StudentId"] = "STUDENT_ID";
  JumioDocumentSubType2["TaxId"] = "TAX_ID";
  JumioDocumentSubType2["Unknown"] = "UNKNOWN";
  JumioDocumentSubType2["Visa"] = "VISA";
  return JumioDocumentSubType2;
})(JumioDocumentSubType || {});
var JumioDocumentType = /* @__PURE__ */ ((JumioDocumentType2) => {
  JumioDocumentType2["CustomId"] = "CUSTOM_ID";
  JumioDocumentType2["IdCard"] = "ID_CARD";
  JumioDocumentType2["LicenseDriver"] = "LICENSE_DRIVER";
  JumioDocumentType2["Passport"] = "PASSPORT";
  JumioDocumentType2["ProofOfAddress"] = "PROOF_OF_ADDRESS";
  JumioDocumentType2["ProofOfPayment"] = "PROOF_OF_PAYMENT";
  JumioDocumentType2["Unsupported"] = "UNSUPPORTED";
  JumioDocumentType2["Visa"] = "VISA";
  return JumioDocumentType2;
})(JumioDocumentType || {});
class JumioLocation {
  __typename;
  city;
  country;
  formatted;
  line1;
  line2;
  postal_code;
  subdivision;
}
class JumioLocationInput {
  city;
  country;
  formatted;
  line1;
  line2;
  postal_code;
  subdivision;
}
class KycCheckResults {
  __typename;
  history;
  uid;
  username;
}
class KycCheckResultsFilter {
  doc_type;
  status;
  submission_date_ts;
  text;
}
class KycCheckResultsInput {
  history;
  uid;
}
var KycCheckType = /* @__PURE__ */ ((KycCheckType2) => {
  KycCheckType2["Jumio"] = "JUMIO";
  return KycCheckType2;
})(KycCheckType || {});
class KycDocument {
  __typename;
  client_ip;
  country_info;
  device_id;
  device_verified;
  did;
  dob;
  doc_id_sub_type;
  doc_ref_id;
  doc_type;
  first_name;
  gender;
  geolocation_verified;
  ip_verified;
  last_name;
  location;
  number;
  /** Timestamp when the document was uploaded by player */
  received_at_ts;
  status;
  /** Timestamp when the document was requested */
  uploaded_ts;
}
class KycDocumentInput {
  client_ip;
  country_info;
  device_id;
  device_verified;
  did;
  dob;
  doc_id_sub_type;
  doc_ref_id;
  doc_type;
  first_name;
  gender;
  geolocation_verified;
  ip_verified;
  last_name;
  location;
  number;
  received_at_ts;
  status;
  uploaded_ts;
}
var KycReasonCode = /* @__PURE__ */ ((KycReasonCode2) => {
  KycReasonCode2["CcDep"] = "CCDep";
  KycReasonCode2["Hrj"] = "HRJ";
  KycReasonCode2["NoEmail"] = "NoEmail";
  KycReasonCode2["Others"] = "Others";
  KycReasonCode2["PePs"] = "PEPs";
  KycReasonCode2["Payment"] = "Payment";
  KycReasonCode2["Proac"] = "Proac";
  KycReasonCode2["Referral"] = "Referral";
  KycReasonCode2["Security"] = "Security";
  return KycReasonCode2;
})(KycReasonCode || {});
var KycStatus = /* @__PURE__ */ ((KycStatus2) => {
  KycStatus2["Failed"] = "FAILED";
  KycStatus2["None"] = "NONE";
  KycStatus2["Pending"] = "PENDING";
  KycStatus2["Successful"] = "SUCCESSFUL";
  KycStatus2["Uploaded"] = "UPLOADED";
  return KycStatus2;
})(KycStatus || {});
class KycStatusInput {
  id;
  status;
}
class KeycloakLog {
  __typename;
  date;
  details;
  log_id;
  operation_type;
  operator_uuid;
  resource_type;
  target_user_uuid;
}
class KeycloakLogsFilter {
  date;
  operation_type;
  operator_uuid;
  resource_type;
  target_user_uuid;
}
class KeycloakLogsPage {
  __typename;
  items;
}
class Label {
  __typename;
  id;
  name;
}
class LabelGroup {
  __typename;
  color;
  id;
  labels;
  name;
  source_type;
}
class LabelGroupFilter {
  source_type;
  text;
}
class LabelGroupInput {
  color;
  name;
  source_type;
}
class LabelGroupPage {
  __typename;
  items;
  total_count;
}
var LabelGroupSourceType = /* @__PURE__ */ ((LabelGroupSourceType2) => {
  LabelGroupSourceType2["Custom"] = "Custom";
  LabelGroupSourceType2["System"] = "System";
  return LabelGroupSourceType2;
})(LabelGroupSourceType || {});
class LabelInput {
  group_id;
  name;
}
var LimitDurationType = /* @__PURE__ */ ((LimitDurationType2) => {
  LimitDurationType2["Daily"] = "DAILY";
  LimitDurationType2["Monthly"] = "MONTHLY";
  LimitDurationType2["Weekly"] = "WEEKLY";
  return LimitDurationType2;
})(LimitDurationType || {});
class Location {
  __typename;
  city;
  country;
  latitude;
  longitude;
  state;
}
class LocationInput {
  city;
  country;
  latitude;
  longitude;
  state;
}
var LoginStatus = /* @__PURE__ */ ((LoginStatus2) => {
  LoginStatus2["Failed"] = "Failed";
  LoginStatus2["Success"] = "Success";
  return LoginStatus2;
})(LoginStatus || {});
var LoginType = /* @__PURE__ */ ((LoginType2) => {
  LoginType2["App"] = "App";
  LoginType2["Web"] = "Web";
  return LoginType2;
})(LoginType || {});
class LogoutInfo {
  __typename;
  logged_out_at_ts;
}
class ManualCreditApprover {
  __typename;
  daily_amount;
  igp_account_email;
  igp_account_id;
  notification_account_email;
}
class ManualCreditApproverFilter {
  text;
}
class ManualCreditApproverInput {
  daily_amount;
  igp_account_email;
  igp_account_id;
  notification_account_email;
}
class ManualCreditApproverPage {
  __typename;
  items;
  total_count;
}
class ManualCreditCase {
  __typename;
  amount;
  approver_email;
  approver_id;
  bulk_id;
  case_id;
  comment;
  created_by_email;
  created_by_id;
  license;
  on_behalf_of_email;
  on_behalf_of_id;
  reason;
  reference;
  requested_approver_emails;
  requested_approver_ids;
  status;
  submitted_at;
  turnover;
  uid;
  updated_at;
  username;
}
class ManualCreditCaseFilter {
  amount;
  reason;
  requested_approver_email;
  status;
  submitted_at;
  text;
}
class ManualCreditCaseInput {
  amount;
  comment;
  created_by_email;
  created_by_id;
  currency;
  reason;
  reference;
  requested_approver_emails;
  requested_approver_ids;
  turnover_rate;
  uid;
}
class ManualCreditCasePage {
  __typename;
  items;
  total_amount;
  total_count;
}
var ManualCreditCaseStatus = /* @__PURE__ */ ((ManualCreditCaseStatus2) => {
  ManualCreditCaseStatus2["Approved"] = "Approved";
  ManualCreditCaseStatus2["Pending"] = "Pending";
  ManualCreditCaseStatus2["Rejected"] = "Rejected";
  return ManualCreditCaseStatus2;
})(ManualCreditCaseStatus || {});
class ManualCreditCaseStatusUpdateInput {
  approver_email;
  approver_id;
  case_id;
  on_behalf_of_email;
  on_behalf_of_id;
  status;
}
class ManualTransaction {
  __typename;
  amount;
  created_by_uid;
  currency;
  payment_method_description;
  reasons;
  transaction_id;
  turnover_rate;
  type;
  uid;
}
class ManualTransactionInput {
  amount;
  created_by_uid;
  currency;
  /** unique identifier to guarantee operation idempotence; optional for backward compatibility */
  id;
  note;
  payment_method_description;
  reasons;
  turnover_rate;
  type;
  uid;
}
class MarketingCode {
  __typename;
  /** BO user id who added code */
  added_by_uid;
  btag;
  created_at;
  /** marketing code which players enter to get bonus */
  marketing_code;
  /** player id of agent who is the owner of Team code */
  referrer_id;
  type;
}
class MarketingCodeDeleteInput {
  btag;
  marketing_code;
  type;
}
class MarketingCodeFilterInput {
  text;
  type;
}
class MarketingCodeInput {
  added_by_uid;
  btag;
  created_at;
  marketing_code;
  /** player id of agent who is the owner of Team code */
  referrer_id;
  type;
}
class MarketingCodesPage {
  __typename;
  items;
  total_count;
}
class MasterAgent {
  __typename;
  commission_subtypes;
  uid;
}
class Mutation {
  __typename;
  /**
   * Activates draft campaign
   *
   * ### Policies: ###
   *
   * Available if auth token contains `flash-campaign:update`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Campaign is not found
   *
   * `INCORRECT_STATUS`: Only Draft campaign can be activated
   */
  activateFlashCampaign;
  addAccountVerification;
  addAdminAction;
  addAdminFriendGroup;
  addAgentProfile;
  addAggregatedFinanceSummary;
  addAmlLabels;
  addBackpackItem;
  /**
   * ### Description ###
   *
   * Create new keycloak user with temporary password
   *
   * ### Return value ###
   *
   * id of created user
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin` OR `agent-manager`
   *
   * ### Validation: ###
   *
   * `USERNAME_ALREADY_EXISTS`: Username already exist
   *
   * `EMAIL_ALREADY_EXISTS`: Email already exist
   *
   * `PLAYER_ID_NOT_EXISTS`: Player ID does not exist
   *
   * `PLAYER_ID_ALREADY_LINKED`: Player ID already linked to another user
   */
  addBoUser;
  /**
   * creates new bonus in Bonus Engine. Used for all types of bonuses
   *
   * ### Policies: ###
   *
   * auth token contains `entity-bonus` OR `entity-bonus:update`
   */
  addBonusCode;
  addBonusCodeHistory;
  addBotGroup;
  /**
   * ### Policies: ###
   *
   * ** Auth token contains `admin`
   */
  addDebtResponsibleMasterAgent;
  addDetectedBotGroup;
  addEventLogRecord;
  addGeoCheck;
  addGeoCheckSummary;
  /**
   * adds IP to blacklist
   *
   * ### Policies: ###
   *
   * auth token contains `blacklist` OR `blacklist:update` policy
   */
  addIpToBlacklist;
  addKYCResult;
  addLabel;
  addLabelGroup;
  /**
   * ### Policies: ###
   *
   * auth token contains `credit-approver:update`
   */
  addManualCreditApprover;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for manual credit cases under this license
   */
  addManualCreditCase;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for manual credit cases under this license
   */
  addManualCreditCases;
  /**
   * ### Policies: ###
   *
   * ** For all users: **
   *     (
   *         transaction type is credit
   *         AND (auth token contains `credit-limit-1:create` OR `credit-limit-2:create` OR `credit-limit-3:create`)
   *         AND user daily credit limits is not reached
   *     ) OR (
   *         transaction type is debit
   *         AND auth token contains `debit:create`
   *     )
   * )
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  addManualTransaction;
  /**
   * ### Policies: ###
   *
   * ** For all users: **
   *     (
   *         transaction type is credit
   *         AND (auth token contains `credit-limit-1:create` OR `credit-limit-2:create` OR `credit-limit-3:create`)
   *         AND user daily credit limits is not reached
   *     ) OR (
   *         transaction type is debit
   *         AND auth token contains `debit:create`
   *     )
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  addManualTransactions;
  /**
   * creates new marketing code which players can enter in the app to get bonus. Returns added marketing code
   *
   * ### Policies: ###
   *
   * auth token has `entity-bonus:create`
   */
  addMarketingCode;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` apply for items related to players under this license
   */
  addNote;
  /**
   * ### Policies: ###
   *
   * auth token contains `internal` OR `internal:update` OR `p2p-config:create`
   * @deprecated Use addP2PGlobalSettingsV2 mutation
   */
  addP2PGlobalSettings;
  /**
   * ### Policies: ###
   *
   * auth token contains `internal` OR `internal:update` OR `p2p-config:create`
   */
  addP2PGlobalSettingsV2;
  addP2PPlayerLimits;
  /**
   * creates the list of P2P Transfer transactions.
   *
   * ### Policies: ###
   *
   * auth token contains `entity-transaction:p2p-transfer:create`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   * ### Validation: ###
   *
   * Both players of single transfer must be in `P2P` channel
   */
  addP2PTransferBulkOperation;
  /**
   * ### Validation: ###
   *
   * Both players must be in `P2P` channel
   */
  addP2PTransferTransaction;
  addPaymentDetails;
  addPlayerBonus;
  addPlayerReferral;
  addPlayerReferrer;
  /**
   * adds a referrer summary info of a player
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` or `entity-all:update`
   */
  addPlayerReferrerSummary;
  addPlayerRelations;
  addPokerStatistics;
  addRGUserLimit;
  /**
   * Creates referral link base url for aal + license pair
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin`
   *
   * ### Error codes: ###
   *
   * `CONFIG_ALREADY_EXIST`: Config already exists for AAL
   *
   * `INVALID_URL`: Invalid URL is passed
   */
  addReferralLinkConfig;
  /**
   * adds a referrer of a player
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` OR `entity-all:update` AND doesn't contain `clp`
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     -   mutation is available for all players
   *
   * ** For agent managers: ** Auth token contains `agent-manager` policy:
   *     -   mutation is available for players under their AAL list
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  addReferrer;
  /**
   * ### Policies ###
   *
   * user has `kyc-processing` OR `kyc-processing:update` policy
   *
   * ### Action History ###
   *
   * - event_name: `addedSourceOfFunds`
   * - value: {type, others_source_details}
   *
   * ### Error Codes ###
   *
   * `SOURCE_OF_FUNDS_EXISTS`: there is already source of funds with such uid, type and others_source_details
   *
   * `SOURCE_OF_FUNDS_PLAYER_LICENSE`: source of funds can be added only for curacao players
   */
  addSourceOfFunds;
  addUnboundReferral;
  addUser;
  addUserBlackList;
  addUserBlockedStakesAccess;
  addUserCountry;
  addUserDevice;
  addUserGame;
  addUserIp;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  addUserLabels;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  addUserLabelsOperation;
  addUserLogin;
  addUserLogout;
  addUserReCaptchaScore;
  addUserSecurityCase;
  addUserSecurityLimit;
  addUserTransaction;
  addUserVpn;
  add_p2p_transfer_verification;
  /**
   * Adjust agents Debt by creating new Debt Transfer Log
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Agent not fount
   *
   * `NOT_POSITIVE_AMOUNT`: Amount must be greater than 0
   *
   * `AMOUNT_EXCEED_DEBT`: Debt deduction cannot exceed current debt amount
   */
  adjustAgentDebt;
  /**
   * Archives draft or completed campaign
   *
   * ### Policies: ###
   *
   * Available if auth token contains `flash-campaign:update`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Campaign is not found
   *
   * `INCORRECT_STATUS`: Only Completed, Draft or Paused campaign can be archived
   */
  archiveFlashCampaign;
  /**
   * assign list of kyc cases
   *
   * ### Policies: ###
   *
   * auth token contains `entity-all` OR `entity-all:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  assignKYCBulkOperation;
  /**
   * assign list of transactions
   *
   * ### Policies: ###
   *
   * auth token contains `entity-all` OR `entity-all:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  assignTransactionBulkOperation;
  /**
   * assigns clubs for a user
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   */
  assignUserClubs;
  /**
   * creates Revenue Share transaction
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token (contains `entity-all:update` OR `entity-transaction:revenue-share:update`) AND (doesn’t contain `agent:read` AND `agent:update`)
   *
   * ** For agents: ** auth token contains (`entity-all:update` OR `entity-transaction:revenue-share:update`) AND (`agent:read` OR `agent:update`) AND (`uid` param is linked to `sub` from Auth token)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  claimRevenueShare;
  /**
   * Copies existing campaign
   *
   * ### Policies: ###
   *
   * Available if auth token contains `flash-campaign:update`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Campaign is not found
   */
  cloneFlashCampaign;
  /**
   * Creates new Flash Campaign with given settings
   *
   * ### Policies: ###
   *
   * Available if auth token contains `flash-campaign:update`
   */
  createFlashCampaign;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     -   mutation is available
   *
   * ### Error Codes ###
   *
   * `PLAYER_IS_NOT_MASTER_AGENT`: master_agent_uid is not master agent (is not from DebtResponsibleMasterAgent collection)
   *
   * `AGENT_IS_NOT_DOWNLINE_OF_MASTER_AGENT`: from_agent_uid is not in the downline hierarchy of the master_agent_uid
   */
  createRepaymentLog;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   *
   * Error codes:
   *
   * `TURNOVER_CONFIG_ALREADY_EXIST`: Settings for Countries under are already created. In the details there should be a list of countries that already have settings configured
   *
   * `TURNOVER_RATE_MUST_BE_WHOLE_NUMBER`: Turnover rate must be a whole number (e.g., 100 = 100%). Negative values or decimals are not allowed.
   */
  createTurnoverConfig;
  /**
   * deactivates and blocks the bonus from further use
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-bonus` OR `entity-bonus:update`
   *
   * ** For agents **: not allowed
   */
  deactivateBonus;
  deleteBotGroup;
  /**
   * removes the list of marketing codes. Returns deleted codes
   *
   * ### Policies: ###
   *
   * auth token has `entity-bonus:delete`
   */
  deleteMarketingCodes;
  /**
   * ### Policies: ###
   *
   * auth token contains `internal` OR `internal:update` OR `p2p-config:delete`
   * @deprecated Use deleteP2PGlobalSettingsV2
   */
  deleteP2PGlobalSettings;
  /**
   * ### Policies: ###
   *
   * auth token contains `internal` OR `internal:update` OR `p2p-config:delete`
   */
  deleteP2PGlobalSettingsV2;
  deletePlayerRelation;
  deletePokerStatistics;
  /**
   * ### Policies ###
   *
   * user has `kyc-processing` OR `kyc-processing:update` policy
   *
   * ### Action History ###
   *
   * - event_name: `deletedSourceOfFunds`
   * - value: {type, others_source_details}
   *
   * ### Error Codes ###
   *
   * `SOURCE_OF_FUNDS_NOT_FOUND`: source of funds does not exist
   */
  deleteSourceOfFunds;
  /**
   * delete transaction
   *
   * ### Policies: ###
   *
   * auth token has `customer-support` or `customer-support:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for transactions created by players under this license
   */
  deleteTransaction;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   */
  deleteTurnoverConfig;
  deleteUser;
  deleteUserBlackList;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  deleteUserLabel;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  deleteUserLabelsOperation;
  deleteUserSecurityCase;
  /**
   * Edits existing Flash Campaign
   *
   * ### Policies: ###
   *
   * Available if auth token contains `flash-campaign:update`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Campaign is not found
   *
   * `PAUSED_CAMPAIGN_EDITING`: Only end_date allowed to be edited for Paused campaigns
   *
   * `INCORRECT_STATUS`: Only Draft and Paused campaigns can be edited
   */
  editFlashCampaign;
  /**
   * ### Policies: ###
   *
   * auth token contains `credit-approver:update`
   */
  editManualCreditApprover;
  /**
   * Updates referral link base url for aal + license pair
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Config is not found
   *
   * `INVALID_URL`: Invalid URL is passed
   */
  editReferralLinkConfig;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     -   mutation is available
   *
   * ### Error Codes ###
   *
   * `REPAYMENT_LOG_NOT_FOUND`: reapyment log with reapyment_id does not exists
   *
   * `PLAYER_IS_NOT_MASTER_AGENT`: master_agent_uid is not master agent (is not from DebtResponsibleMasterAgent collection)
   *
   * `AGENT_IS_NOT_DOWNLINE_OF_MASTER_AGENT`: from_agent_uid is not in the downline hierarchy of the master_agent_uid
   */
  editRepaymentLog;
  /**
   * Force expire cash bonus. It sends request to Bonus Engine to force expire player cash bonus.
   * When successful result received form Bonus Engine need to update PlayerBonus and add new EventLogRecord
   * with event_name `ForceExpireCashBonus` and bonus status in prev_value and next_value
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   *
   * ** For agents **: not allowed
   */
  forceExpireCashBonus;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  initNdrpKYC;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  initPaymentKYC;
  /**
   * init list of payment kyc cases
   *
   * ### Policies: ###
   *
   * auth token contains `entity-all` OR `entity-all:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  initPaymentKYCBulkOperation;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  initSecurityKYC;
  /**
   * ### Policies: ###
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:account` OR `action-center:account:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockAccount;
  /**
   * lock and unlock login for multiple players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:account` OR `action-center:account:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockAccountBulkOperation;
  /**
   * lock and unlock casino games access for players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`
   *
   * ** For agents: ** auth token contains `agent:update` AND (`action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`) AND (player is an agent's direct referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockCasino;
  /**
   * lock and unlock casino games access for multiple players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`
   *
   * ** For agents: ** auth token contains `agent:update` AND (`action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`) AND (player is an agent's direct referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockCasinoBulkOperation;
  /**
   * ### Policies: ###
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:finance` OR `action-center:finance:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockDeposit;
  /**
   * lock and unlock deposit for multiple players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:finance` OR `action-center:finance:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockDepositBulkOperation;
  /**
   * ### Policies: ###
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockLobby;
  /**
   * lock and unlock lobby access for multiple players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockLobbyBulkOperation;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:p2p` OR `action-center:p2p:update`
   *
   * ** For agents: ** auth token contains `agent:update` AND (`action-center` OR `action-center:update` OR `action-center:p2p` OR `action-center:p2p:update`) AND (player is an agent's direct referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockP2pBulkOperation;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:p2p` OR `action-center:p2p:update`
   *
   * ** For agents: ** auth token contains `agent:update` AND (`action-center` OR `action-center:update` OR `action-center:p2p` OR `action-center:p2p:update`) AND (player is an agent's direct referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   * @deprecated Use updateP2PPlayerSettingsV2
   */
  lockP2pFeature;
  /**
   * lock and unlock sportsbook transaction access for players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`
   *
   * ** For agents: ** auth token contains `agent:update` AND (`action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`) AND (player is an agent's direct referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   * if auth token contains `internal` OR `internal:update` mutation available for all players
   */
  lockSportsbook;
  /**
   * lock and unlock sportsbook transaction for multiple players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`
   *
   * ** For agents: ** auth token contains `agent:update` AND (`action-center` OR `action-center:update` OR `action-center:games` OR `action-center:games:update`) AND (player is an agent's direct referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   * if auth token contains `internal` OR `internal:update` mutation available for all players
   */
  lockSportsbookBulkOperation;
  /**
   * ### Policies: ###
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:finance` OR `action-center:finance:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockWithdrawal;
  /**
   * lock and unlock withdrawal for multiple players
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:finance` OR `action-center:finance:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  lockWithdrawalBulkOperation;
  /**
   * Logs out a player from a specific casino game provider
   *
   * ### Policies: ###
   *
   * auth token has `customer-support` or `customer-support:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  logoutCasinoGames;
  /**
   * Logs out a player from a specific casino game provider
   *
   * ### Policies: ###
   *
   * auth token has `customer-support` or `customer-support:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  logoutCasinoHaba;
  orderFailed;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center` OR `action-center:update` OR `action-center:p2p` OR `action-center:p2p:update`
   *
   * ** For agents: ** auth token contains `agent:update` AND (`action-center` OR `action-center:update` OR `action-center:p2p` OR `action-center:p2p:update`) AND (player is an agent's direct referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  p2pOverrideFeature;
  /**
   * Pauses Active campaign, stops point calculation
   *
   * ### Policies: ###
   *
   * Available if auth token contains `flash-campaign:update`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Campaign is not found
   *
   * `INCORRECT_STATUS`: Only Active campaigns can be paused
   */
  pauseFlashCampaign;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  reInitPaymentKYCDocument;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  reOpenPaymentKYC;
  removeAmlLabels;
  /**
   * ### Policies: ###
   *
   * ** Auth token contains `admin`
   */
  removeDebtResponsibleMasterAgent;
  /**
   * deletes a failed order (marks as deleted)
   *
   * ### Policies: ###
   *
   * auth token has `customer-support` or `customer-support:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for orders created by players under this license
   */
  removeFailedOrder;
  /**
   * removes IP from blacklist
   *
   * ### Policies: ###
   *
   * auth token contains `blacklist` OR `blacklist:update` policy
   */
  removeIpFromBlacklist;
  /**
   * ### Policies: ###
   *
   * auth token contains `credit-approver:update`
   */
  removeManualCreditApprover;
  /**
   * Removes referral link base url for aal + license pair
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Config is not found
   */
  removeReferralLinkConfig;
  /**
   * removes a referrer of a player
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update` AND doesn’t contain `clp` AND `agent` AND `agent:update`
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     -   mutation is available for all players
   *
   * ** For agent managers: ** Auth token contains `agent-manager` policy:
   *     -   mutation is available for players under their AAL list
   *
   *
   * ** For agents: ** auth token contains `agent` OR `agent:update` AND player is an agent's direct referee
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  removeReferrer;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     -   mutation is available
   *
   * ### Error Codes ###
   *
   * `REPAYMENT_LOG_NOT_FOUND`: reapyment log with reapyment_id does not exists
   */
  removeRepaymentLog;
  /** remove turnover config from db */
  removeTurnoverConfig;
  /**
   * ### Description ###
   *
   * Resets password of user to temporary password
   *
   * ### Return value ###
   *
   * id of updated user
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin` OR `agent-manager`
   */
  resetPassword;
  /**
   * ### Return value: ###
   *
   * uid
   *
   * ### Policies: ###
   *
   * user has `security-code` OR `security-code:update` policy
   *
   * ### Data Segregation Policies ###
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   * ### Action History ###
   *
   * - event_name: `resetSecurityCode`
   * - value: String (status)
   */
  resetSecurityCode;
  /**
   * Resumes Paused campaign
   *
   * ### Policies: ###
   *
   * Available if auth token contains `flash-campaign:update`
   *
   * ### Error codes: ###
   *
   * `NOT_FOUND`: Campaign is not found
   *
   * `INCORRECT_STATUS`: Only PAUSED campaigns can be resumed
   *
   * `DATE_CONFLICT`: Paused campaign conflicts with another active campaign on the same license and date range
   */
  resumeFlashCampaign;
  /**
   * retries a failed order
   *
   * ### Policies: ###
   *
   * auth token has `customer-support` or `customer-support:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for orders created by players under this license
   */
  retryFailedOrder;
  /**
   * retry transaction
   *
   * ### Policies: ###
   *
   * auth token has `customer-support` or `customer-support:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for transactions created by players under this license
   */
  retryTransaction;
  /** save turnover config in db */
  saveTurnoverConfig;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  sendMessage;
  syncKeycloak;
  testTimeout;
  triggerCasino;
  /**
   * triggers the bonus for a single player
   *
   * ### Policies: ###
   *
   * auth token contains `entity-bonus` OR `entity-bonus:update`
   */
  triggerPlayerBonus;
  /**
   * triggers the bonus for the list of players
   *
   * ### Policies: ###
   *
   * auth token contains `entity-bonus` OR `entity-bonus:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  triggerPlayerBonuses;
  /**
   * unassigns clubs from a user
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   */
  unassignUserClubs;
  /**
   * ### Description ###
   *
   * Removes keycloak agent user
   *
   * ### Return value ###
   *
   * id of removed user
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin`
   *
   * ### Validation: ###
   *
   * `BO_USER_NOT_EXISTS` BO User ID does not exists
   *
   * `BO_USER_IS_NOT_AGENT` BO User ID does not exists
   */
  unlinkAgent;
  /**
   * ### Return value: ###
   *
   * uid
   *
   * ### Policies: ###
   *
   * auth token contains `otp` OR `otp:update` policy
   *
   * ### Data Segregation Policies ###
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   * ### Action History ###
   *
   * - event_name: `unlockPlayerLoginOTP`
   */
  unlockPlayerLoginOTP;
  /**
   * ### Description ###
   *
   * Update user posibility to login into account
   *
   * ### Return value ###
   *
   * id of updated user
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin` OR `agent-manager`
   *
   * ### Validation: ###
   *
   * `BO_USER_NOT_EXISTS` BO User ID does not exists
   */
  updateAccountStatus;
  updateAccountVerification;
  updateAdminFriendGroup;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateAffiliateBtag;
  updateAfterRegistration;
  updateAggregatedFinanceSummary;
  updateAggregatedLifetimeBonus;
  updateBackpackItem;
  /**
   * ### Description ###
   *
   * Updates info for existing keycloak user
   *
   * ### Return value ###
   *
   * id of updated user
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin` OR `agent-manager`
   *
   * ### Validation: ###
   *
   * `EMAIL_ALREADY_EXISTS`: Email already exist
   *
   * `PLAYER_ID_NOT_EXISTS`: Player ID does not exist
   *
   * `PLAYER_ID_ALREADY_LINKED`: Player ID already linked to another user
   *
   * `GROUP_ID_NOT_EXISTS` Group ID does not exists
   *
   * `BO_USER_NOT_EXISTS` BO User ID does not exists
   */
  updateBoUser;
  /**
   * updates default referrer settings for regular players
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` or `entity-all:update`
   */
  updateDefaultPlayerReferralSettings;
  updateFailedOrder;
  updateGeoCheck;
  updateGeoCheckSummary;
  /**
   * update list of kyc cases
   *
   * ### Policies: ###
   *
   * auth token contains `entity-all` OR `entity-all:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateKYCBulkOperation;
  updateKYCResult;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateKycDocumentStatus;
  updateLabel;
  updateLabelGroup;
  /**
   * ### Policies: ###
   *
   * auth token contains `credit:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for manual credit cases under this license
   */
  updateManualCreditCaseStatus;
  /**
   * ### Policies: ###
   *
   * auth token contains `credit:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for manual credit cases under this license
   */
  updateManualCreditCaseStatuses;
  /**
   * updates the status of NDRP case (only **Approved** and **DeniedNdrpKYC** statuses are allowed)
   * - `kyc_case_id`: The unique identifier for the KYC case.
   * - `status`: The new status for the account verification.
   * - `auto_update`: Flag to indicate if the update should be automatic.
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateNdrpKYC;
  /**
   * ### Description ###
   *
   * Updates users non-withdrawable balance wich affects also withdrawable balance
   *
   * ### Returns ###
   *
   * uid of updated user profile
   *
   * ### Policies: ###
   *
   * user has `wd-balance` OR `wd-balance:update` policy
   *
   * ### Action History ###
   *
   * - event_name: `updateNonWithdrawableBalance`
   * - value: Float
   *
   * ### Error Codes ###
   *
   * `PLAYER_NOT_FOUND`: player with provided `uid` not found
   *
   * `EXCEED_TOTAL_BALANCE`: non-withdrawable balance can not be greater that total balance
   *
   * `CAN_NOT_BE_NEGATIVE_NUMBER`: non-withdrawable balance must be 0 or greater
   */
  updateNonWithdrawableBalance;
  /**
   * updates a note
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` or `entity-all:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` apply for items related to players under this license
   */
  updateNote;
  /**
   * ### Policies: ###
   *
   * auth token contains `internal` OR `internal:update` OR `p2p-config:update`
   * @deprecated Use updateP2PGlobalSettingsV2
   */
  updateP2PGlobalSettings;
  /**
   * ### Policies: ###
   *
   * auth token contains `internal` OR `internal:update` OR `p2p-config:update`
   */
  updateP2PGlobalSettingsV2;
  /**
   *     ### Policies: ###
   *
   *     ** For all users: ** auth token contains `p2p-amount:update`
   *
   *     ### License Policies: ###
   *
   *     `license-kr`
   *
   *     `license-ph`
   *
   *     `license-mx`
   *
   *     `license-cn`
   *
   *     `license-cis`
   *
   *     `license-curacao`
   *
   *     `license-tobique`
   *
   *     `license-anjouan`
   *
   *     if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   *     ### Error handling ###
   *
   *     Error code with limits are received from PE
   *
   *     List of Errors:
   *
   *     1. Daily limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Daily P2P transfer limit cannot exceed 20000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_DAILY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Daily P2P transfer limit cannot exceed 20000"
   *                 },
   *                 "data": {
   *                     "limitType": "daily",
   *                     "limitAmount": 20000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     2. Weekly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Weekly P2P transfer limit cannot exceed 100000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_WEEKLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Weekly P2P transfer limit cannot exceed 100000"
   *                 },
   *                 "data": {
   *                     "limitType": "weekly",
   *                     "limitAmount": 100000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     3. Monthly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Monthly P2P transfer limit cannot exceed 200000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_MONTHLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Monthly P2P transfer limit cannot exceed 200000"
   *                 },
   *                 "data": {
   *                     "limitType": "monthly",
   *                     "limitAmount": 200000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   * @deprecated Use updateP2PPlayerSettingsV2
   */
  updateP2PPlayerLimits;
  /**
   *     ### Policies: ###
   *
   *     ** For all users: ** auth token contains `p2p-amount:update`
   *
   *     ### License Policies: ###
   *
   *     `license-kr`
   *
   *     `license-ph`
   *
   *     `license-mx`
   *
   *     `license-cn`
   *
   *     `license-cis`
   *
   *     `license-curacao`
   *
   *     `license-tobique`
   *
   *     `license-anjouan`
   *
   *     if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   *     ### Error handling ###
   *
   *     Error code with limits are received from PE
   *
   *     List of Errors:
   *
   *     1. Daily limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Daily P2P transfer limit cannot exceed 20000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_DAILY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Daily P2P transfer limit cannot exceed 20000"
   *                 },
   *                 "data": {
   *                     "limitType": "daily",
   *                     "limitAmount": 20000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     2. Weekly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Weekly P2P transfer limit cannot exceed 100000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_WEEKLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Weekly P2P transfer limit cannot exceed 100000"
   *                 },
   *                 "data": {
   *                     "limitType": "weekly",
   *                     "limitAmount": 100000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     3. Monthly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Monthly P2P transfer limit cannot exceed 200000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_MONTHLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Monthly P2P transfer limit cannot exceed 200000"
   *                 },
   *                 "data": {
   *                     "limitType": "monthly",
   *                     "limitAmount": 200000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   * @deprecated Use updateP2PPlayerSettingsV2
   */
  updateP2PPlayerLimitsV2;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `action-center:update` OR `action-center:p2p-lock:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateP2PPlayerLock;
  /**
   *     ### Policies: ###
   *
   *     ** For all users: ** auth token contains `p2p-amount:update` OR `action-center:update` OR `action-center:p2p-lock:update`
   *
   *     ### License Policies: ###
   *
   *     `license-kr`
   *
   *     `license-ph`
   *
   *     `license-mx`
   *
   *     `license-cn`
   *
   *     `license-cis`
   *
   *     `license-curacao`
   *
   *     `license-tobique`
   *
   *     `license-anjouan`
   *
   *     if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   *     ### Error handling ###
   *
   *     Error code with limits are received from PE
   *
   *     List of Errors:
   *
   *     1. Daily limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Daily P2P transfer limit cannot exceed 20000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_DAILY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Daily P2P transfer limit cannot exceed 20000"
   *                 },
   *                 "data": {
   *                     "limitType": "daily",
   *                     "limitAmount": 20000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     2. Weekly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Weekly P2P transfer limit cannot exceed 100000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_WEEKLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Weekly P2P transfer limit cannot exceed 100000"
   *                 },
   *                 "data": {
   *                     "limitType": "weekly",
   *                     "limitAmount": 100000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     3. Monthly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Monthly P2P transfer limit cannot exceed 200000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_MONTHLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Monthly P2P transfer limit cannot exceed 200000"
   *                 },
   *                 "data": {
   *                     "limitType": "monthly",
   *                     "limitAmount": 200000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   * @deprecated Use updateP2PPlayerSettingsV2
   */
  updateP2PPlayerSettings;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `p2p-amount:update` OR `action-center:update` OR `action-center:p2p-lock:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   * @deprecated Use updateP2PPlayerSettingsV2BulkOperation
   */
  updateP2PPlayerSettingsBulkOperation;
  /**
   *     ### Policies: ###
   *
   *     ** For all users: ** auth token contains `p2p-amount:update` OR `action-center:update` OR `action-center:p2p-lock:update`
   *
   *     ### License Policies: ###
   *
   *     `license-kr`
   *
   *     `license-ph`
   *
   *     `license-mx`
   *
   *     `license-cn`
   *
   *     `license-cis`
   *
   *     `license-curacao`
   *
   *     `license-tobique`
   *
   *     `license-anjouan`
   *
   *     if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   *     ### Error handling ###
   *
   *     Error code with limits are received from PE
   *
   *     List of Errors:
   *
   *     1. Daily limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Daily P2P transfer limit cannot exceed 20000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_DAILY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Daily P2P transfer limit cannot exceed 20000"
   *                 },
   *                 "data": {
   *                     "limitType": "daily",
   *                     "limitAmount": 20000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     2. Weekly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Weekly P2P transfer limit cannot exceed 100000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_WEEKLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Weekly P2P transfer limit cannot exceed 100000"
   *                 },
   *                 "data": {
   *                     "limitType": "weekly",
   *                     "limitAmount": 100000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   *
   *     3. Monthly limit exceeds max:
   *
   * ```
   * {
   *     "errors": [
   *         {
   *             "message": "Monthly P2P transfer limit cannot exceed 200000",
   *             ...,
   *             "extensions": {
   *                 "errorType": "P2P_MONTHLY_LIMIT_EXCEEDS_MAXIMUM",
   *                 "errorInfo": {
   *                     "validation_errors": "Monthly P2P transfer limit cannot exceed 200000"
   *                 },
   *                 "data": {
   *                     "limitType": "monthly",
   *                     "limitAmount": 200000
   *                 }
   *             }
   *         }
   *     ]
   * }
   * ```
   */
  updateP2PPlayerSettingsV2;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `p2p-amount:update` OR `action-center:update` OR `action-center:p2p-lock:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateP2PPlayerSettingsV2BulkOperation;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updatePaymentKYC;
  updatePlayerBalanceSummary;
  updatePlayerBonus;
  updatePlayerFinanceSummary;
  updatePlayerReferral;
  updatePlayerReferrer;
  /**
   * updates a referrer summary info of a player
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` or `entity-all:update`
   */
  updatePlayerReferrerSummary;
  /**
   * Updates player verified contact. Must be unique for each player
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `email` OR `email:update` OR `phone` OR `phone:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updatePlayerVerifiedContact;
  updateRGUserLimit;
  updateReferralSettings;
  /**
   * updates a referrer of a player
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` OR `entity-all:update` AND doesn't contain `clp`
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     -   mutation is available for all players
   *
   * ** For agent managers: ** Auth token contains `agent-manager` policy:
   *     -   mutation is available for players under their AAL list
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateReferrer;
  /**
   * updates referral settings (revenue share, expiration date) for regular players only
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` or `entity-all:update`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateRegularPlayerReferralSettings;
  updateReputationScores;
  /**
   * ### Description ###
   *
   * Appends revenue share to default_agent_revenue_share_history
   *
   * ### Returns ###
   *
   * agent_id of agent that was updated
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update` AND doesn't contain `clp`
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     -   mutation is available for all agents
   *
   * ** For agent managers: ** Auth token contains `agent-manager` policy:
   *     -   mutation is available for agents under their AAL list
   *
   * ### Error Codes ###
   *
   * `AGENT_NOT_FOUND`: agent with provided `agent_id` not found
   *
   * `INVALID_SUBAGENT_REVENUE_SHARE`: some of provided revenue share is higher than parent agent
   */
  updateRevenueShare;
  /**
   * ### Policies: ###
   *
   * user has `security-code` OR `security-code:update` policy
   */
  updateSecurityCodesConfiguration;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   */
  updateSecurityKYC;
  /**
   * ### Policies: ###
   *
   * auth token contains `internal` OR `internal:update`
   */
  updateTransactionWithdrawableBalance;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   *
   * Error codes:
   *
   * `TURNOVER_CONFIG_ALREADY_EXIST`: Settings for Countries under are already created. In the details there should be a list of countries that already have settings configured
   *
   * `TURNOVER_RATE_MUST_BE_WHOLE_NUMBER`: Turnover rate must be a whole number (e.g., 100 = 100%). Negative values or decimals are not allowed.
   */
  updateTurnoverConfig;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:update` mutation available for players under this license
   *
   * if auth token contains `admin` mutation available for all players
   *
   * if auth token contains `agent-manager` mutation avaliable for all agents under their AAL list
   */
  updateUser;
  updateUser2FA;
  updateUserChallengeQuestion;
  updateUserComplianceResult;
  updateUserIdentity;
  /**
   * updates player's license type and corresponding country and state
   * ### Policies: ###
   *
   * available if auth token contains `license` OR `license:update`
   */
  updateUserLicense;
  updateUserLogin;
  updateUserNdrp;
  updateUserSecurityLimit;
  updateUserTransaction;
  updateUsersBiggestValues;
  upsertBonusCode;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:update`
   */
  upsertPageView;
  validateUsersBets;
  whitelistBulkOperation;
}
class NgrSummary {
  __typename;
  cash_ngr;
  casino_ngr;
  mtt_ngr;
  poker_ngr;
  total;
}
class Note {
  __typename;
  attachments;
  body;
  entity;
  id;
  /**
   * shows if note is pinned or not
   *
   * default value: false
   */
  is_pinned;
  note_type;
  posted_at;
  posted_by_uid;
  users_tagged;
  workspace;
}
class NoteInput {
  attachments;
  body;
  entity;
  /**
   * shows if note is pinned or not
   *
   * default value: false
   */
  is_pinned;
  note_type;
  posted_at;
  posted_by_uid;
  users_tagged;
  workspace;
}
var NoteType = /* @__PURE__ */ ((NoteType2) => {
  NoteType2["Global"] = "Global";
  NoteType2["Request"] = "Request";
  return NoteType2;
})(NoteType || {});
class NotesFilterInput {
  /** filter by entity and parent entity id should be supported */
  entity;
  /** filter to fetch all vs pinned/unpinned notes */
  is_pinned;
  text;
  /** filter type to fetch all vs record specific notes */
  type;
  /** filter by one of the workspace for which note was added */
  workspace;
}
var NotesFilterType = /* @__PURE__ */ ((NotesFilterType2) => {
  NotesFilterType2["AllRecords"] = "AllRecords";
  NotesFilterType2["Specific"] = "Specific";
  return NotesFilterType2;
})(NotesFilterType || {});
class NotesPage {
  __typename;
  items;
  total_count;
}
class NumRange {
  max;
  min;
}
var OperationType = /* @__PURE__ */ ((OperationType2) => {
  OperationType2["Action"] = "ACTION";
  OperationType2["Create"] = "CREATE";
  OperationType2["Delete"] = "DELETE";
  OperationType2["Update"] = "UPDATE";
  return OperationType2;
})(OperationType || {});
class OtherSummary {
  __typename;
  cost_tournament_overlay_excl_freeroll;
}
class P2PGlobalConfigsFilter {
  agent_related;
  countries;
  kyc_approved;
  licenses;
  p2p_sender;
  p2p_status;
}
class P2PGlobalSettings {
  __typename;
  country;
  credit_limits;
  daily_transfer_count;
  debit_limits_to_agent;
  debit_limits_to_player;
  /** @deprecated Replaced with `p2p_sender` */
  is_agent;
  kyc_status;
  license_type;
  /** @deprecated Replaced with `credit_limits`, `debit_limits_to_agent`, `debit_limits_to_player` */
  limits;
  p2p_sender;
  p2p_status;
  updated_at;
  updated_by;
}
class P2PGlobalSettingsInput {
  country;
  is_agent;
  kyc_status;
  license_type;
  limits;
  p2p_status;
}
class P2PGlobalSettingsPage {
  __typename;
  items;
  total;
}
class P2PGlobalSettingsV2Input {
  country;
  credit_limits;
  daily_transfer_count;
  debit_limits_to_agent;
  debit_limits_to_player;
  kyc_status;
  license_type;
  p2p_sender;
  p2p_status;
}
class P2PLimits {
  __typename;
  daily;
  monthly;
  weekly;
}
class P2PLimitsInput {
  daily;
  monthly;
  weekly;
}
class P2PLog {
  __typename;
  amount;
  attempt_id;
  debit_started_ts;
  debit_transaction_id;
  error_message;
  /** Sender's current license type */
  license_type;
  receiver_uid;
  receiver_username;
  sender_uid;
  sender_username;
  status;
}
class P2PLogFilter {
  debit_started_ts;
  text;
}
class P2PLogInput {
  amount;
  attempt_id;
  debit_started_ts;
  debit_transaction_id;
  error_message;
  /** Sender's current license type */
  license_type;
  receiver_uid;
  receiver_username;
  sender_uid;
  sender_username;
  status;
}
class P2PLogPage {
  __typename;
  items;
  total_count;
}
var P2PLogStatus = /* @__PURE__ */ ((P2PLogStatus2) => {
  P2PLogStatus2["Failed"] = "Failed";
  P2PLogStatus2["Successful"] = "Successful";
  return P2PLogStatus2;
})(P2PLogStatus || {});
class P2PPersonalLimits {
  __typename;
  credit_limits;
  daily_transfer_count;
  debit_limits_to_agent;
  debit_limits_to_player;
}
class P2PPersonalLimitsInput {
  credit_limits;
  daily_transfer_count;
  debit_limits_to_agent;
  debit_limits_to_player;
}
class P2PPlayerSettingsInput {
  limits;
  /**
   * if p2p_override_status false:
   * - other fields are ignored
   *
   * if p2p_override_status true:
   * - p2p_status and limits are required
   */
  p2p_override_status;
  p2p_status;
}
class P2PPlayerSettingsV2Input {
  credit_limits;
  daily_transfer_count;
  debit_limits_to_agent;
  debit_limits_to_player;
  /**
   * if p2p_override_status false:
   * - other fields are ignored
   *
   * if p2p_override_status true:
   * - p2p_status and limits are required
   */
  p2p_override_status;
  p2p_status;
}
class P2PRankingReport {
  __typename;
  counterparts;
  /** Sender's current license type */
  license_type;
  total_amount;
  total_count;
  uid;
}
class P2PRankingReportFilter {
  transaction_started_ts;
}
class P2PRankingReportPage {
  __typename;
  items;
  total_count;
}
var P2PSender = /* @__PURE__ */ ((P2PSender2) => {
  P2PSender2["Agent"] = "Agent";
  P2PSender2["AgentPlayer"] = "AgentPlayer";
  P2PSender2["NormalPlayer"] = "NormalPlayer";
  return P2PSender2;
})(P2PSender || {});
class P2PTransferInput {
  amount;
  created_by_uid;
  type;
  uid;
}
class P2PTransferResponse {
  __typename;
  success;
}
class PageView {
  __typename;
  last_opened_at;
  page_id;
  user_id;
}
class PageViewFilter {
  last_opened_at;
  page_ids;
}
class PageViewInput {
  last_opened_at;
  page_id;
}
class PaymentDetailsInput {
  amount;
  bank_card;
  bank_card_name;
  cancel_default;
  change_amount;
  createtime;
  match_id;
  match_status;
  plat;
  status;
  successtime;
  uid;
  vip_level;
}
var PaymentOption = /* @__PURE__ */ ((PaymentOption2) => {
  PaymentOption2["PaymentOptionAstropaycard"] = "PaymentOptionAstropaycard";
  PaymentOption2["PaymentOptionBankintl"] = "PaymentOptionBankintl";
  PaymentOption2["PaymentOptionBanklocal"] = "PaymentOptionBanklocal";
  PaymentOption2["PaymentOptionCreditcard"] = "PaymentOptionCreditcard";
  PaymentOption2["PaymentOptionCryptocurrency"] = "PaymentOptionCryptocurrency";
  PaymentOption2["PaymentOptionDebitcard"] = "PaymentOptionDebitcard";
  PaymentOption2["PaymentOptionFastbankttransfer"] = "PaymentOptionFastbankttransfer";
  PaymentOption2["PaymentOptionNeteller"] = "PaymentOptionNeteller";
  PaymentOption2["PaymentOptionNone"] = "PaymentOptionNone";
  PaymentOption2["PaymentOptionPaypal"] = "PaymentOptionPaypal";
  PaymentOption2["PaymentOptionQiwi"] = "PaymentOptionQiwi";
  PaymentOption2["PaymentOptionSkrill"] = "PaymentOptionSkrill";
  PaymentOption2["PaymentOptionYandex"] = "PaymentOptionYandex";
  return PaymentOption2;
})(PaymentOption || {});
class PaymentStatus {
  __typename;
  msg;
  status;
}
var PaymentSystem = /* @__PURE__ */ ((PaymentSystem2) => {
  PaymentSystem2["Hexopay"] = "Hexopay";
  PaymentSystem2["None"] = "None";
  PaymentSystem2["Nuvei"] = "Nuvei";
  PaymentSystem2["PayPal"] = "PayPal";
  PaymentSystem2["PremierCashier"] = "PremierCashier";
  return PaymentSystem2;
})(PaymentSystem || {});
var PaymentVendor = /* @__PURE__ */ ((PaymentVendor2) => {
  PaymentVendor2["DevCode"] = "DevCode";
  PaymentVendor2["Hexopay"] = "Hexopay";
  PaymentVendor2["Intech"] = "Intech";
  PaymentVendor2["None"] = "None";
  PaymentVendor2["Nuvei"] = "Nuvei";
  PaymentVendor2["OkaysPay"] = "OkaysPay";
  PaymentVendor2["PayPal"] = "PayPal";
  PaymentVendor2["PremierCashier"] = "PremierCashier";
  PaymentVendor2["Thapay"] = "Thapay";
  return PaymentVendor2;
})(PaymentVendor || {});
class PayoutReport {
  __typename;
  agent_uid;
  agent_username;
  casino;
  country;
  global_spins;
  payout_report_id;
  player_uid;
  player_username;
  poker_cash;
  poker_mtt;
  poker_plo;
  sports;
  total_share;
  transaction_date;
}
class PayoutReportsFilter {
  referrer;
  text;
  transaction_date;
}
class PayoutReportsPage {
  __typename;
  items;
  total_count;
}
class PhoneNumber {
  __typename;
  area;
  full_number;
  mobile;
}
class PhoneNumberInput {
  area;
  full_number;
  mobile;
}
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["Bl"] = "BL";
  Platform2["Im"] = "IM";
  Platform2["Meme"] = "MEME";
  Platform2["Mt"] = "MT";
  Platform2["Nj"] = "NJ";
  Platform2["None"] = "NONE";
  Platform2["Pkw"] = "PKW";
  Platform2["Wpk"] = "WPK";
  Platform2["Wpto"] = "WPTO";
  return Platform2;
})(Platform || {});
class PlayerActivitySummary {
  __typename;
  cash_game_hands_played;
  /** @deprecated Moved to PlayerEcologySummary */
  ecology_flag;
  mtt_played;
  net_deposit;
  player_profit_loss;
  player_win_loss;
}
class PlayerBalanceSummary {
  __typename;
  balance;
  generated_rake;
  payment_methods;
}
class PlayerBalanceSummaryInput {
  balance;
  generated_rake;
  payment_methods;
}
class PlayerBonus {
  __typename;
  bonus_engine_code;
  bonus_id;
  bonus_name;
  bonus_status;
  created_at;
  desc;
  expire_at;
  marketing_code;
  realized_amount;
  total_amount;
  type;
  uid;
}
class PlayerBonusInput {
  bonus_engine_code;
  bonus_id;
  bonus_name;
  bonus_status;
  created_at;
  desc;
  expire_at;
  marketing_code;
  realized_amount;
  total_amount;
  trigger_by;
  trigger_by_uid;
  type;
  uid;
}
var PlayerBonusStatus = /* @__PURE__ */ ((PlayerBonusStatus2) => {
  PlayerBonusStatus2["Active"] = "Active";
  PlayerBonusStatus2["Complete"] = "Complete";
  PlayerBonusStatus2["Expired"] = "Expired";
  PlayerBonusStatus2["Pending"] = "Pending";
  return PlayerBonusStatus2;
})(PlayerBonusStatus || {});
class PlayerBonusTriggerInput {
  bonus_id;
  bonus_name;
  event_type;
  meta;
  timestamp;
  uid;
}
class PlayerBonusTriggerMetaInput {
  amount;
  currency;
  marketing_code;
  ticket_count;
}
class PlayerBonusesFilter {
  text;
  type;
}
class PlayerBonusesPage {
  __typename;
  items;
  total_count;
}
class PlayerCashierOtp {
  __typename;
  /**
   * ### Policies: ###
   *
   * Auth token should have `otp:read` policy to return the value
   */
  active_code;
  status;
  uid;
}
var PlayerCashierOtpStatus = /* @__PURE__ */ ((PlayerCashierOtpStatus2) => {
  PlayerCashierOtpStatus2["Active"] = "Active";
  PlayerCashierOtpStatus2["Inactive"] = "Inactive";
  return PlayerCashierOtpStatus2;
})(PlayerCashierOtpStatus || {});
class PlayerDepositSummary {
  __typename;
  amount;
  currency;
  total_number;
}
class PlayerDepositSummaryInput {
  amount;
  currency;
  total_number;
}
class PlayerEcologySummary {
  __typename;
  ecology_flag;
  is_pro_shortdeck;
  is_pro_zoom;
  stake_2_is_pro_nlhe;
  stake_4_is_pro_nlhe;
  stake_10_is_pro_nlhe;
  stake_20_is_pro_nlhe;
  stake_50_is_pro_nlhe;
  stake_100_is_pro_nlhe;
  stake_200_is_pro_nlhe;
  stake_400_is_pro_nlhe;
}
class PlayerEcologyWeeklyReport {
  __typename;
  agent_uid;
  agent_username;
  country;
  ecology_summary;
  player_uid;
  player_username;
  report_week_start;
  row_id;
}
class PlayerEcologyWeeklyReportFilter {
  referrer;
  report_week_date;
  text;
}
class PlayerEcologyWeeklyReportPage {
  __typename;
  items;
  total_count;
}
class PlayerFinanceSummary {
  __typename;
  balance;
  bonus_ratio;
  casino_coin_balance;
  deposit;
  generated_rake;
  ggr;
  ggr_lifetime;
  lifetime_bonus;
  non_withdrawable_balance;
  p2p_credit;
  p2p_debit;
  payment_methods;
  withdrawable_balance;
  withdrawal;
}
class PlayerFinanceSummaryInput {
  balance;
  bonus_ratio;
  casino_coin_balance;
  deposit;
  generated_rake;
  ggr;
  lifetime_bonus;
  non_withdrawable_balance;
  payment_methods;
  withdrawable_balance;
  withdrawal;
}
class PlayerGamesSummary {
  __typename;
  cash_game_hand_played;
  mtt_played;
  player_net_deposit;
  player_profit_loss;
}
class PlayerLoginOtp {
  __typename;
  /**
   * Returns value from API only if player is under PUKE brand, otherwise return null
   *
   * Auth token should have `otp:read` policy to return the value
   */
  active_code;
  last_reset_at;
  last_reset_by;
  status;
  uid;
}
var PlayerLoginOtpStatus = /* @__PURE__ */ ((PlayerLoginOtpStatus2) => {
  PlayerLoginOtpStatus2["Active"] = "Active";
  PlayerLoginOtpStatus2["Inactive"] = "Inactive";
  PlayerLoginOtpStatus2["Locked"] = "Locked";
  return PlayerLoginOtpStatus2;
})(PlayerLoginOtpStatus || {});
class PlayerMessage {
  __typename;
  content;
  id;
  mail_type;
  sender;
  sender_id;
  sent_at;
  signature;
  source;
  subject;
  title;
  uid;
}
class PlayerMessageFilterInput {
  mail_type;
  sent_at;
  source;
  text;
}
class PlayerMessageInput {
  content;
  mail_type;
  sender;
  sender_id;
  sent_at;
  signature;
  source;
  subject;
  title;
  uid;
}
var PlayerMessageMailType = /* @__PURE__ */ ((PlayerMessageMailType2) => {
  PlayerMessageMailType2["AsyncAnnounce"] = "AsyncAnnounce";
  PlayerMessageMailType2["Mail"] = "Mail";
  PlayerMessageMailType2["RealAnnounce"] = "RealAnnounce";
  return PlayerMessageMailType2;
})(PlayerMessageMailType || {});
var PlayerMessageSource = /* @__PURE__ */ ((PlayerMessageSource2) => {
  PlayerMessageSource2["Bo"] = "BO";
  PlayerMessageSource2["Cio"] = "CIO";
  return PlayerMessageSource2;
})(PlayerMessageSource || {});
class PlayerMessagesPage {
  __typename;
  items;
  total_count;
}
class PlayerReferral {
  __typename;
  expiration_date;
  invite_code;
  is_agent;
  referee;
  referee_uid;
  referrer_id;
  revenue_generated_total;
  revenue_share;
  revenue_share_offering_status;
}
class PlayerReferralInput {
  invite_code;
  referee_uid;
  referrer_id;
}
class PlayerReferralsFilter {
  referrer_id;
  text;
}
class PlayerReferralsPage {
  __typename;
  items;
  total_count;
}
class PlayerReferrerSummary {
  __typename;
  invite_code;
  redeem_pending_total;
  referrer;
  revenue_generated_total;
  revenue_redeemed_total;
  revenue_share;
}
class PlayerSecuritySummary {
  __typename;
  gto_score;
  player_skill;
}
class PlayerSecuritySummaryInput {
  gto_score;
  player_skill;
}
class PlayerSkill {
  __typename;
  custom_label;
  label;
  score;
}
var PlayerSkillCustomLabel = /* @__PURE__ */ ((PlayerSkillCustomLabel2) => {
  PlayerSkillCustomLabel2["Undefined"] = "Undefined";
  PlayerSkillCustomLabel2["Vip"] = "VIP";
  return PlayerSkillCustomLabel2;
})(PlayerSkillCustomLabel || {});
class PlayerSkillInput {
  custom_label;
  label;
  score;
}
var PlayerSkillLabel = /* @__PURE__ */ ((PlayerSkillLabel2) => {
  PlayerSkillLabel2["NonPro"] = "NonPro";
  PlayerSkillLabel2["Pro"] = "Pro";
  return PlayerSkillLabel2;
})(PlayerSkillLabel || {});
class PlayerSourceOfFunds {
  __typename;
  last_updated_at;
  request_date_at;
  sources;
  uid;
}
class PlayerUidInput {
  uid;
}
class PlayerVerificationInfo {
  __typename;
  is_address_ssn_verified;
  is_email_verified;
  is_phone_verified;
}
class PlayerVerificationInfoInput {
  is_address_ssn_verified;
  is_email_verified;
  is_phone_verified;
}
var PlayerVerificationStatus = /* @__PURE__ */ ((PlayerVerificationStatus2) => {
  PlayerVerificationStatus2["Failed"] = "Failed";
  PlayerVerificationStatus2["InProgress"] = "InProgress";
  PlayerVerificationStatus2["NotVerified"] = "NotVerified";
  PlayerVerificationStatus2["Passed"] = "Passed";
  return PlayerVerificationStatus2;
})(PlayerVerificationStatus || {});
class PlayerWithdrawalSummary {
  __typename;
  amount;
  currency;
  total_number;
}
class PlayerWithdrawalSummaryInput {
  amount;
  currency;
  total_number;
}
var PlayersGroup = /* @__PURE__ */ ((PlayersGroup2) => {
  PlayersGroup2["BotPlayer"] = "BotPlayer";
  PlayersGroup2["Evidence"] = "Evidence";
  PlayersGroup2["Undefined"] = "Undefined";
  return PlayersGroup2;
})(PlayersGroup || {});
class PlayersRelation {
  __typename;
  created_at;
  id;
  player;
  related_player;
  relation_type;
  relevance;
  security_case_types;
}
class PlayersRelationFilter {
  created_at;
  players_group;
  security_case_types;
  text;
}
class PlayersRelationInput {
  created_at;
  player;
  related_player;
  relation_type;
  relevance;
  security_case_types;
}
class PlayersRelationPage {
  __typename;
  items;
  total_count;
}
var PlayersRelationType = /* @__PURE__ */ ((PlayersRelationType2) => {
  PlayersRelationType2["BankCard"] = "BankCard";
  PlayersRelationType2["BankCardName"] = "BankCardName";
  PlayersRelationType2["Device"] = "Device";
  PlayersRelationType2["Ip"] = "Ip";
  PlayersRelationType2["Subnet"] = "Subnet";
  return PlayersRelationType2;
})(PlayersRelationType || {});
class PokerMttSummary {
  __typename;
  mtt_ggr;
  mtt_ngr;
  mtt_ticket_bonus;
  mtt_total_buyin;
  player_mtt_win_loss;
  poker_mtt_fees;
}
class PokerNlheSummary {
  __typename;
  ggr_poker_prev_180_days;
  /** @deprecated Field no longer supported */
  is_pro;
  /** @deprecated Moved to PlayerEcologySummary */
  is_pro_shortdeck;
  nlhe_add_on_ggr_usd_pro;
  nlhe_ggr_usd_pro;
  nlhe_high_ggr_usd_pro;
  nlhe_insurance_ggr_usd_pro;
  nlhe_jackpot_ggr_usd_pro;
  nlhe_low_ggr_usd_pro;
  nlhe_medium_ggr_usd_pro;
  nlhe_micro_ggr_usd_pro;
  nlhe_rakes_ggr_usd_pro;
  player_nlhe_shortdeck_win_loss_lifetime;
  player_nlhe_shortdeck_win_loss_prev_180_days;
  shortdeck_add_on_ggr_usd_pro;
  shortdeck_ggr_usd_pro;
  shortdeck_insurance_ggr_usd_pro;
  shortdeck_rakes_ggr_usd_pro;
}
class PokerPloSummary {
  __typename;
  plo_ggr;
}
class PokerSummary {
  __typename;
  poker_addons;
  poker_addons_add_on;
  poker_addons_guess;
  poker_addons_insurance;
  poker_ggr;
  poker_ggr_usd_pro_ecology_modified;
  poker_ngr;
  poker_rake;
  poker_share;
}
class PrizeDistribution {
  __typename;
  end_rank;
  prize_usd;
  start_rank;
}
class PrizeDistributionInput {
  end_rank;
  prize_usd;
  start_rank;
}
class PrizePool {
  __typename;
  blind_id;
  distribution;
  totals;
}
class PrizePoolInput {
  blind_id;
  distribution;
  totals;
}
class PrizePoolTotals {
  __typename;
  total_prize_usd_per_day;
  total_rank_in_money_per_day;
}
class PrizePoolTotalsInput {
  total_prize_usd_per_day;
  total_rank_in_money_per_day;
}
class ProPlayer {
  __typename;
  platform;
  pro;
  third_id;
  uid;
  update_time;
}
class ProPlayerFilter {
  platform;
  update_time;
}
class ProPlayerPage {
  __typename;
  items;
  total_count;
}
class ProSummary {
  __typename;
  cost_ftd_bonus_pro;
  cost_psp_fee_pro;
  cost_spins_tournament_tickets_pro;
  is_pro_shortdeck;
  nlhe_ggr_usd_pro;
  nlhe_high_ggr_usd_pro;
  nlhe_low_ggr_usd_pro;
  nlhe_medium_ggr_usd_pro;
  nlhe_micro_ggr_usd_pro;
  poker_ggr_usd_pro;
  shortdeck_ggr_usd_pro;
}
class Query {
  __typename;
  /**
   * returns weekly Revenue Share History
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   *
   * Auth token has `agent-manager` policy: access for all agents within his AAL
   *
   * Auth token has `agent` policy: access for his data and downline agents data
   */
  exportAgentNegativeCarryoverReport;
  /**
   *     returns csv report for sub agents and players invited by agents
   *
   *     ### Policies ###
   *
   * ** For all users: ** auth token has
   *     (`entity-all` OR `entity-all:read`)
   *      policies
   *
   *     ** For agents: ** auth token has
   *     (`agent` OR `agent:read`)
   *     policies
   *
   *     ** For agent-managers: ** auth token has
   *     (`agent-manager` OR `agent-manager:read`)
   *     policies
   */
  exportAgentPlayerReportingsV2;
  /**
   * returns daily Revenue Share History report url
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   *
   * Auth token has `agent-manager` policy: access for all agents within his AAL
   *
   * Auth token has `agent` policy: access for his data and downline agents data
   */
  exportAgentRevenueShareDailyReport;
  /**
   * returns weekly Revenue Share History report url
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   *
   * Auth token has `agent-manager` policy: access for all agents within his AAL
   *
   * Auth token has `agent` policy: access for his data and downline agents data
   */
  exportAgentRevenueShareWeeklyReportV2;
  /**
   *     returns country report for agent managers
   *
   *     ### Policies ###
   *
   * ** For all users: ** auth token has
   *     (`entity-all` OR `entity-all:read`)
   *      policies
   *
   *     ** For agent-managers: ** auth token has
   *     (`agent-manager` OR `agent-manager:read`)
   *     policies
   */
  exportCountryLevelReport;
  /**
   * ### Policies: ###
   *
   * ** Auth token contains `admin` policy: all debt responsible master agents are available
   *
   * ** Auth token contains `agent` policy: only this agent is available if he is debt responsible master agent
   */
  exportDebtResponsibleMasterAgents;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy
   *
   * ** For agents: ** Auth token contains `agent` AND agent is `master agent` AND agent is DebtResponsibleMasterAgent (there is user with playerId from token in DebtResponsibleMasterAgent collection)
   */
  exportDebtTransferLogs;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     - can view all logs
   *
   * ** For agent managers and country-level partner: ** Auth token contains `agent-manager` policy:
   *     - can view logs where agent_uid is under their AAL list
   *
   * ** For agents: ** Auth token contains `agent` policy:
   *     - can view logs where agent_uid being themselves
   *
   * ### Aggregation ###
   *
   * When transaction_date filter passed, aggregate all reports grouped by combination of player_uid and agent_uid for selected DateRange
   */
  exportPayoutReports;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     - can view all reports
   *
   * ** For agent managers and country-level partner: ** Auth token contains `agent-manager` policy:
   *     - can view reports where agent uid is under their AAL list
   *
   * ** For agent: ** Auth token contains `agent` policy:
   *     - can view reports where agent_uid being themselves or their downlines
   */
  exportPlayerEcologyWeeklyReports;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     - can view all logs
   *
   * ** For agents: ** Auth token contains `agent` AND agent is Debt Responsible Master Agent:
   *     - can only view logs where master_agent_uid being themselves
   */
  exportRepaymentLogs;
  /**
   * returns the list of players csv report
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is and agent which called the query OR his direct referee OR his downstream referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  exportUserProfiles;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is and agent which called the query OR his direct referee OR his downstream referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  exportUsersTransactions;
  /**
   * returns weekly Revenue Share History
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   */
  exportWeeklySummary;
  fakeError;
  generateCaseNumber;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getAccountVerifications;
  /**
   * returns weekly Revenue Share History
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   *
   * Auth token has `agent-manager` policy: access for all agents within his AAL
   *
   * Auth token has `agent` policy: access for his data and downline agents data
   */
  getAgentNegativeCarryoverReport;
  /**
   * returns reports for sub agents and players invited by agents.
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has `entity-all` OR `entity-all:read` policy
   *
   * ** For agents: ** auth token has `agent` OR `agent:read` policy
   */
  getAgentPathStatistics;
  /**
   * returns reports for sub agents and players invited by agents.
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-all` OR `entity-all:read`) AND (`license-tobique` OR `license-tobique:read) policies
   *
   * ** For agents: ** auth token has (`agent` OR `agent:read`) AND (`license-tobique` OR `license-tobique:read) policies
   * AND reports belongs to sub agents or players referred by an agent whose id in the token and with `license_type` = Tobique
   */
  getAgentPlayerReportings;
  /**
   * returns reports for sub agents and players invited by agents, agents without referees
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-all` OR `entity-all:read`) AND (`license-kr` OR `license-kr:read`) policy
   *
   * ** For agents: ** auth token has (`agent` OR `agent:read`) AND (`license-kr` OR `license-kr:read`) policies AND reports belongs to player directly referred by an agent or agent without referee whose id in the token
   */
  getAgentPlayerReportingsKr;
  /**
   * returns reports for sub agents and players invited by agents.
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-all` OR `entity-all:read`) AND (`license-tobique` OR `license-tobique:read) policies
   *
   * ** For agents: ** auth token has (`agent` OR `agent:read`) AND (`license-tobique` OR `license-tobique:read) policies
   * AND reports belongs to sub agents or players referred by an agent whose id in the token and with `license_type` = Tobique
   */
  getAgentPlayerReportingsNew;
  /**
   *     returns reports for sub agents and players invited by agents.
   *
   *     ### Policies ###
   *
   * ** For all users: ** auth token has
   *     (`entity-all` OR `entity-all:read`)
   *      policies
   *
   *     ** For agents: ** auth token has
   *     (`agent` OR `agent:read`)
   *     policies
   *
   *     ** For agent-managers: ** auth token has
   *     (`agent-manager` OR `agent-manager:read`)
   *     policies
   */
  getAgentPlayerReportingsV2;
  /**
   * returns reports for sub agents and players invited by agents, agents without referees
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-all` OR `entity-all:read`) AND (`license-tobique` OR `license-tobique:read`) policy
   *
   * ** For agents: ** auth token has (`agent` OR `agent:read`) AND (`license-tobique` OR `license-tobique:read`) policies AND reports belongs to sub agents or players referred by an agent whose id in the token and with `license_type` = Tobique
   */
  getAgentPlayerReportingsVn;
  /**
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-all` OR `entity-all:read`) AND (`license-tobique` OR `license-tobique:read`) policy
   *
   * ** For agents: ** auth token has (`agent` OR `agent:read`) AND (`license-tobique` OR `license-tobique:read`) policies AND reports belongs to sub agents or players referred by an agent whose id in the token and with `license_type` = Tobique
   */
  getAgentPlayerReportingsVnNew;
  /**
   * returns list of agent profiles
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has `entity-all` OR `entity-all:read`
   *
   * ** For agents: ** (auth token has `agent` OR `agent:read`) AND (result user profiles are agents in agent tree of user who called query)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getAgentProfiles;
  /**
   * returns list of agent profiles
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has `entity-all` OR `entity-all:read`
   *
   * ** For agents: ** (auth token has `agent` OR `agent:read`) AND (result user profiles are agents in agent tree of user who called query)
   *
   * if auth token contains `license-kr` OR `license-kr:read` return items related to players with `license_type` = KR
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getAgentProfilesNew;
  /**
   * returns daily Revenue Share History
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   *
   * Auth token has `agent-manager` policy: access for all agents within his AAL
   *
   * Auth token has `agent` policy: access for his data and downline agents data
   */
  getAgentRevenueShareDailyReport;
  /**
   * returns weekly Agent level reports for ROW agents
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-all` OR `entity-all:read`) user has access to players data according to License Policies
   *
   * ** For agents: ** auth token has (`agent` OR `agent:read`) user has access to own data
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getAgentRevenueShareWeeklyReport;
  /**
   * returns weekly Revenue Share History
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   *
   * Auth token has `agent-manager` policy: access for all agents within his AAL
   *
   * Auth token has `agent` policy: access for his data and downline agents data
   */
  getAgentRevenueShareWeeklyReportV2;
  /**
   * returns list of aggregated financial summary
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has `entity-all` OR `entity-all:read` policy
   *
   * ** For agents: ** (auth token has `agent` OR `agent:read`) AND (result items are owned by direct or downstream referees)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getAggregatedFinanceSummaries;
  /**
   * returns aggregated financial summary based on historical data
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has `entity-all` OR `entity-all:read` policy
   *
   * ** For agents: ** (auth token has `agent` OR `agent:read`) AND (result items are owned by direct or downstream referees)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getAggregatedFinanceSummary;
  getAutoWithdrawalRulesData;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getBackpackItem;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getBackpackItems;
  getBoUserSettings;
  /**
   * ### Description ###
   *
   * Returns list of keycloak users that available for current user
   *
   * For user with `aal_manager_x` group will return only users with `aal_x` group
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin` OR `agent-manager`
   */
  getBoUsers;
  /**
   * returns the list of bonuses triggered
   *
   * ### Policies: ###
   *
   * auth token contains `entity-bonus` OR `entity-bonus:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getBonusCodeHistory;
  getBonusCodes;
  getBotGroups;
  /**
   * returns current status of operation and each bulk item
   *
   * ### Policies ###
   *
   * auth token has `entity-all:read`, `entity-bulk:read`
   */
  getBulkOperationResult;
  /**
   * returns the list of operations
   *
   * ### Policies ###
   *
   * auth token has `entity-all:read`, `entity-bulk:read`
   */
  getBulkOperationResults;
  /**
   * returns list of clubs
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has `entity-all:read`
   */
  getClubs;
  /**
   *     returns country report for agent managers
   *
   *     ### Policies ###
   *
   * ** For all users: ** auth token has
   *     (`entity-all` OR `entity-all:read`)
   *      policies
   *
   *     ** For agent-managers: ** auth token has
   *     (`agent-manager` OR `agent-manager:read`)
   *     policies
   */
  getCountryLevelReport;
  /**
   * ### Policies: ###
   *
   * ** Auth token contains `admin` policy: all debt responsible master agents are available
   *
   * ** Auth token contains `agent` policy: only this agent is available if he is debt responsible master agent
   */
  getDebtResponsibleMasterAgents;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy
   *
   * ** For agents: ** Auth token contains `agent` AND agent is `master agent` AND agent is DebtResponsibleMasterAgent (there is user with playerId from token in DebtResponsibleMasterAgent collection)
   */
  getDebtTransferLogs;
  /**
   * returns reports for sub agents and players invited by agents, agents without referees
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-all` OR `entity-all:read`) AND (`license-tobique` OR `license-tobique:read) policies
   *
   * ** For agents: ** auth token has (`agent` OR `agent:read`) AND (`license-tobique` OR `license-tobique:read) policies
   */
  getEmbeddedDashboard;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getEventLogs;
  /**
   * returns the list of pending or processed failed orders
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getFailedOrders;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is and agent which called the query OR his direct referee OR his downstream referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getFailedTransactions;
  /**
   * ### Policise: ###
   *
   * Available if auth token contains `flash-campaign:read`
   */
  getFlashCampaigns;
  getFriendGroups;
  getFullAgentReport;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getGeoCheckSummary;
  /**
   * ### Description ###
   *
   * Returns list of all keycloak groups
   *
   * ### Policies: ###
   *
   * Available if auth token contains `admin` OR `agent-manager`
   */
  getGroups;
  /**
   * returns blacklisted IPs
   *
   * ### Policies: ###
   *
   * auth token contains `entity-all` OR `entity-all:read`
   */
  getIpBlacklist;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     - can view all logs
   */
  getKeycloakLogs;
  getLabelGroups;
  getManualCreditApprovers;
  getManualCreditCases;
  getMarketingCodes;
  /**
   * ### Description ###
   *
   * Return master agent info for agent
   *
   * ### Policies: ###
   *
   * if auth token contains `admin` policy, all master agents available
   *
   * if auth token contain `agent-manager` policy, check that agent in filter is under corresponding aal group, master agent of this agent is available
   *
   * if auth token contain `agent` policy, only master agent of user that send request available
   */
  getMasterAgent;
  /**
   * returns the list of notes
   *
   * ### Policies: ###
   *
   * auth token has `entity-all` or `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getNotes;
  /**
   * ### Policies ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:read`
   */
  getP2PGlobalConfigs;
  /**
   * ### Description ###
   *
   * Returns P2P transaction details. Items with agent receiver or sender should not be returned in this query
   *
   * Player can transfer P2P only if they are under the same license
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token contains `entity-all` or `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getP2PLogs;
  /**
   * ### Description ###
   *
   * Returns Global P2P rule applied to player with uid passed in params
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token contains `entity-all:read`. If user does not have any license-specific role then return empty list
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getP2PPlayerGlobalSettings;
  /**
   * ### Policies ###
   *
   * ** For all users: ** if user does not have any license-specific role then return empty list
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   * @deprecated use getP2PPlayerPersonalLimitsV2
   */
  getP2PPlayerPersonalLimits;
  /**
   * ### Policies ###
   *
   * ** For all users: ** if user does not have any license-specific role then return empty list
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getP2PPlayerPersonalLimitsV2;
  /**
   * ### Description ###
   * Returns top players by transfer amount. Items with agent receiver or sender should not be returned in this query
   *
   * ### Policies ###
   *
   * ** For all users: ** if user does not have any license-specific role them return empty list
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getP2PRankingReport;
  /**
   * ### Policies ###
   *
   * ** For all users: ** auth token contains `entity-all` or `entity-all:read`
   */
  getPageViews;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     - can view all logs
   *
   * ** For agent managers and country-level partner: ** Auth token contains `agent-manager` policy:
   *     - can view logs where agent_uid is under their AAL list
   *
   * ** For agents: ** Auth token contains `agent` policy:
   *     - can view logs where agent_uid being themselves
   *
   * ### Aggregation ###
   *
   * When transaction_date filter passed, aggregate all reports grouped by combination of player_uid and agent_uid for selected DateRange
   */
  getPayoutReports;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerBonus;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerBonuses;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` or `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerCashierOTP;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     - can view all reports
   *
   * ** For agent managers and country-level partner: ** Auth token contains `agent-manager` policy:
   *     - can view reports where agent uid is under their AAL list
   *
   * ** For agent: ** Auth token contains `agent` policy:
   *     - can view reports where agent_uid being themselves or their downlines
   */
  getPlayerEcologyWeeklyReports;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` or `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerLoginOTP;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerMessages;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerReferralLink;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerReferrals;
  /**
   * returns referrer info and his revenue share
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND `uid` param is linked to `sub` from Auth token
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getPlayerReferrerSummary;
  /**
   * getPlayerSourceOfFunds return info only for for Curacao players
   *
   * ### Policies: ###
   *
   * if auth token contains `license-curacao` OR `license-curacao:read` trigger for players with `license_type` = Curacao
   */
  getPlayerSourceOfFunds;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getProPlayers;
  /**
   * ### Policies: ###
   *
   * Available if auth token contains `admin`
   */
  getReferralLinkConfigs;
  getReferralSettings;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items where both `player` and `related_player` are under this license
   */
  getRelatedPlayers;
  /**
   * ### Policies: ###
   *
   * ** For admins: ** Auth token contains `admin` policy:
   *     - can view all logs
   *
   * ** For agents: ** Auth token contains `agent` AND agent is Debt Responsible Master Agent:
   *     - can only view logs where master_agent_uid being themselves
   */
  getRepaymentLogs;
  /**
   * returns list of daily statistics: registrations, first-day deposits, etc.
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has (`entity-report` OR `entity-report:read` OR `entity-report:mkt` OR `entity-report:mkt:read`)
   *
   * ** For club owners: ** auth token has (`club` OR `club:read`) AND (`entity-report` OR `entity-report:read` OR`entity-report:mkt` OR `entity-report:mkt:read`)
   */
  getReportingMarketing;
  getReputationScores;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getRgUsersLimits;
  getSecurityCases;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` or `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getSecurityCodeResetLogs;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getSecurityCodeStatus;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:read`
   */
  getSecurityCodesConfiguration;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getSecurityKYCVerificationStatus;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getSecurityKYCVerificationStatusWPK;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` OR `entity-all:read`
   */
  getTurnoverConfigs;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserActionHistory;
  /**
   * ### Policies ###
   *
   * ** For all users: ** auth token contains `entity-all` or `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is and agent which called the query OR his direct referee OR his downstream referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserActivitySummary;
  /**
   * returns list of user club relations
   *
   * ### Policies ###
   *
   * ** For all users: ** auth token has `entity-all:read`
   */
  getUserClubs;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserGeoChecks;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserKYC;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserKYCWPK;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserLoginHistory;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserPokerStatistics;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return players under this license
   */
  getUserProfile;
  /**
   * returns the list of players. It includes: account details, personal info, financial summary, marketing info, security info
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is and agent which called the query OR his direct referee OR his downstream referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUserProfiles;
  getUserReCaptchaScores;
  getUserUploadedDocuments;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUsersGames;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUsersGeoChecks;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUsersKYC;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUsersLoginHistory;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is and agent which called the query OR his direct referee OR his downstream referee)
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getUsersTransactions;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all` or `entity-all:read`
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` return items related to players under this license
   */
  getVerificationCodes;
  /**
   * returns weekly Revenue Share History
   *
   * ### Policies ###
   *
   * Auth token has `admin` policy: full access to all agent data
   */
  getWeeklySummaryExport;
  search;
}
class Reason {
  __typename;
  created_at_ts;
  reason_code;
  reason_text;
  reason_type;
}
var ReasonCode = /* @__PURE__ */ ((ReasonCode2) => {
  ReasonCode2["Bonus"] = "Bonus";
  ReasonCode2["BountyBonus"] = "BountyBonus";
  ReasonCode2["CancelledByPlayer"] = "CancelledByPlayer";
  ReasonCode2["CasinoManualBonus"] = "CasinoManualBonus";
  ReasonCode2["Cheating"] = "Cheating";
  ReasonCode2["Collusion"] = "Collusion";
  ReasonCode2["Compensation"] = "Compensation";
  ReasonCode2["Confiscation"] = "Confiscation";
  ReasonCode2["ConfiscationBonusAbuse"] = "ConfiscationBonusAbuse";
  ReasonCode2["ConfiscationRpf"] = "ConfiscationRPF";
  ReasonCode2["ConfiscationSec"] = "ConfiscationSec";
  ReasonCode2["Correction"] = "Correction";
  ReasonCode2["DepositNotFullyWagered"] = "DepositNotFullyWagered";
  ReasonCode2["Fraud"] = "Fraud";
  ReasonCode2["FraudulentActivities"] = "FraudulentActivities";
  ReasonCode2["GameplayReview"] = "GameplayReview";
  ReasonCode2["GoodwillGesture"] = "GoodwillGesture";
  ReasonCode2["KycPending"] = "KYCPending";
  ReasonCode2["KycPendingFailed"] = "KYCPendingFailed";
  ReasonCode2["KycRequired"] = "KYCRequired";
  ReasonCode2["ManualDeposit"] = "ManualDeposit";
  ReasonCode2["ManualWithdrawal"] = "ManualWithdrawal";
  ReasonCode2["Marketing"] = "Marketing";
  ReasonCode2["MgmtReview"] = "MgmtReview";
  ReasonCode2["NoCloseLoop"] = "NoCloseLoop";
  ReasonCode2["Other"] = "Other";
  ReasonCode2["OtherCost"] = "OtherCost";
  ReasonCode2["OtherRevenue"] = "OtherRevenue";
  ReasonCode2["P2pTransfer"] = "P2pTransfer";
  ReasonCode2["PspError"] = "PSPError";
  ReasonCode2["PspFailed"] = "PSPFailed";
  ReasonCode2["PspNoFunds"] = "PSPNoFunds";
  ReasonCode2["RakeBack"] = "RakeBack";
  ReasonCode2["ReachRGlimits"] = "ReachRGlimits";
  ReasonCode2["RefundChargeback"] = "RefundChargeback";
  ReasonCode2["RevShareAffiliate"] = "RevShareAffiliate";
  ReasonCode2["RevShareReferral"] = "RevShareReferral";
  ReasonCode2["RevenueShare"] = "RevenueShare";
  ReasonCode2["SecurityCase"] = "SecurityCase";
  ReasonCode2["SystemCorrection"] = "SystemCorrection";
  ReasonCode2["Test"] = "Test";
  ReasonCode2["ThirdDeposit"] = "ThirdDeposit";
  ReasonCode2["Threshold24hrs"] = "Threshold24hrs";
  ReasonCode2["Undefined"] = "Undefined";
  ReasonCode2["UnderInvestigation"] = "UnderInvestigation";
  return ReasonCode2;
})(ReasonCode || {});
class ReasonInput {
  created_at_ts;
  reason_code;
  reason_text;
  reason_type;
}
var ReasonType = /* @__PURE__ */ ((ReasonType2) => {
  ReasonType2["Credit"] = "Credit";
  ReasonType2["Debit"] = "Debit";
  ReasonType2["WithdrawalCancellation"] = "WithdrawalCancellation";
  ReasonType2["WithdrawalFailed"] = "WithdrawalFailed";
  ReasonType2["WithdrawalManualReview"] = "WithdrawalManualReview";
  ReasonType2["WithdrawalOnHold"] = "WithdrawalOnHold";
  ReasonType2["WithdrawalRejection"] = "WithdrawalRejection";
  return ReasonType2;
})(ReasonType || {});
var RefereeType = /* @__PURE__ */ ((RefereeType2) => {
  RefereeType2["None"] = "None";
  RefereeType2["Player"] = "Player";
  RefereeType2["SubAgent"] = "SubAgent";
  return RefereeType2;
})(RefereeType || {});
var ReferralAmountUpdateType = /* @__PURE__ */ ((ReferralAmountUpdateType2) => {
  ReferralAmountUpdateType2["Agent"] = "Agent";
  ReferralAmountUpdateType2["Percentage"] = "Percentage";
  ReferralAmountUpdateType2["Redeem"] = "Redeem";
  ReferralAmountUpdateType2["Revenue"] = "Revenue";
  ReferralAmountUpdateType2["RevenueTotal"] = "RevenueTotal";
  return ReferralAmountUpdateType2;
})(ReferralAmountUpdateType || {});
class ReferralLinkConfig {
  __typename;
  aal_group_name;
  license;
  referral_link_base_url;
}
class ReferralLinkConfigFilterInput {
  aal_group_name;
}
class ReferralLinkConfigInput {
  aal_group_name;
  license;
  referral_link_base_url;
}
class ReferralLinkConfigPage {
  __typename;
  items;
  total_count;
}
class ReferralSettings {
  __typename;
  expiration_period;
  revenue_share;
}
class ReferralSettingsInput {
  expiration_period;
  revenue_share;
}
class ReferralUpdateInput {
  agent_revenue_share_history;
  amount;
  expiration_date;
  is_agent;
  revenue_share;
  uid;
  update_type;
}
class Referrals {
  __typename;
  inviting_user_id;
  inviting_user_username;
  /** Agent's referral code used for link */
  personal_referral_code;
  /** Referral code of the agent who invited the player */
  referral_code;
  referred_at;
}
class ReferralsInput {
  inviting_user_id;
  inviting_user_username;
  personal_referral_code;
  referral_code;
  referred_at;
}
class ReferrerFilter {
  is_agent;
  is_downstream;
  referrer_player_id;
}
var ReferrerType = /* @__PURE__ */ ((ReferrerType2) => {
  ReferrerType2["Affiliate"] = "Affiliate";
  ReferrerType2["P2P"] = "P2P";
  return ReferrerType2;
})(ReferrerType || {});
class RegionPlayerInfo {
  __typename;
  country_of_birth;
  district;
  national_id;
  nationality;
  occupation;
  tax_id;
}
class RegionPlayerInfoInput {
  country_of_birth;
  district;
  national_id;
  nationality;
  occupation;
  tax_id;
}
class RemovePlayerReferralInput {
  referee_uid;
  referrer_id;
}
class RemoveReferralLinkConfigInput {
  aal_group_name;
  license;
}
class RepaymentLog {
  __typename;
  from_agent_uid;
  from_agent_username;
  master_agent_uid;
  master_agent_username;
  repayment_amount;
  repayment_date;
  repayment_id;
}
class RepaymentLogsFilter {
  repayment_date;
  text;
}
class RepaymentLogsPage {
  __typename;
  items;
  total_count;
}
class ReportField {
  column_name;
  field;
}
class ReportLink {
  __typename;
  file_name;
  url;
}
class ReportingFilter {
  club_ids;
  date;
}
class ReportingMarketing {
  __typename;
  club_ids;
  metrics;
  time_series;
}
class ReportingMarketingMetrics {
  __typename;
  active_2nd_day;
  active_3rd_day;
  active_7th_day;
  avg_ltv_1st_day;
  avg_ltv_2st_day;
  avg_ltv_7st_day;
  avg_ltv_14st_day;
  reg_to_deposit;
  reg_to_play;
  total_registrations;
}
class ReportingMarketingTimeSeries {
  __typename;
  active_2nd_day_ratio;
  active_3rd_day_ratio;
  active_7th_day_ratio;
  date;
  first_day_deposit_ratio;
  first_day_play_ratio;
  ltv_2d_avg;
  ltv_7d_avg;
  ltv_14d_avg;
  registered_player_number;
}
var ResourceType = /* @__PURE__ */ ((ResourceType2) => {
  ResourceType2["GroupMembership"] = "GROUP_MEMBERSHIP";
  ResourceType2["User"] = "USER";
  return ResourceType2;
})(ResourceType || {});
var ResultType = /* @__PURE__ */ ((ResultType2) => {
  ResultType2["Failure"] = "Failure";
  ResultType2["Success"] = "Success";
  return ResultType2;
})(ResultType || {});
class RevenueShareClaimInput {
  amount;
  currency;
}
class RevenueShareClaimResult {
  __typename;
  claimstatus;
  transactionId;
}
var RevenueShareOfferingStatus = /* @__PURE__ */ ((RevenueShareOfferingStatus2) => {
  RevenueShareOfferingStatus2["Active"] = "Active";
  RevenueShareOfferingStatus2["Inactive"] = "Inactive";
  return RevenueShareOfferingStatus2;
})(RevenueShareOfferingStatus || {});
var RevenueShareType = /* @__PURE__ */ ((RevenueShareType2) => {
  RevenueShareType2["Direct"] = "Direct";
  RevenueShareType2["None"] = "None";
  RevenueShareType2["SubAgent"] = "SubAgent";
  return RevenueShareType2;
})(RevenueShareType || {});
var RgLimitType = /* @__PURE__ */ ((RgLimitType2) => {
  RgLimitType2["Deposit"] = "DEPOSIT";
  RgLimitType2["DepositBlocked"] = "DEPOSIT_BLOCKED";
  RgLimitType2["Loss"] = "LOSS";
  RgLimitType2["SelfExclusion"] = "SELF_EXCLUSION";
  RgLimitType2["Time"] = "TIME";
  RgLimitType2["Wager"] = "WAGER";
  return RgLimitType2;
})(RgLimitType || {});
class RgMoneyLimitHistory {
  __typename;
  currency;
  duration_type;
  end_at;
  limit;
  limit_id;
  start_at;
  trigger_at;
  type;
  version;
}
class RgMoneyLimitHistoryInput {
  currency;
  duration_type;
  end_at;
  limit;
  limit_id;
  start_at;
  trigger_at;
  type;
}
class RgStateLimitHistory {
  __typename;
  end_at;
  limit_id;
  start_at;
  trigger_at;
  type;
  version;
}
class RgStateLimitHistoryInput {
  end_at;
  limit_id;
  start_at;
  trigger_at;
  type;
}
class RgTimeLimitHistory {
  __typename;
  end_at;
  limit;
  limit_id;
  start_at;
  trigger_at;
  type;
  version;
}
class RgTimeLimitHistoryInput {
  end_at;
  limit;
  limit_id;
  start_at;
  trigger_at;
  type;
}
class RgUserLimits {
  __typename;
  deposit;
  deposit_blocked;
  loss;
  self_exclusion;
  time;
  uid;
  username;
  wager;
}
class RgUserLimitsFilter {
  text;
}
class RgUserLimitsInput {
  deposit;
  deposit_blocked;
  loss;
  self_exclusion;
  time;
  uid;
  username;
  wager;
}
class SaveTurnoverConfig {
  countries;
  id;
  license;
  scope_type;
  turnover_rate;
  updated_at;
  updated_by_uid;
}
var ScopeType = /* @__PURE__ */ ((ScopeType2) => {
  ScopeType2["Country"] = "Country";
  ScopeType2["Global"] = "Global";
  return ScopeType2;
})(ScopeType || {});
class SecurityCase {
  __typename;
  case_id;
  closed_at;
  opened_at;
  type;
}
class SecurityCaseInput {
  case_id;
  closed_at;
  opened_at;
  type;
}
var SecurityCaseType = /* @__PURE__ */ ((SecurityCaseType2) => {
  SecurityCaseType2["Aml"] = "Aml";
  SecurityCaseType2["BlacklistProbable"] = "BlacklistProbable";
  SecurityCaseType2["Bot"] = "Bot";
  SecurityCaseType2["ChipDumping"] = "ChipDumping";
  SecurityCaseType2["Collusion"] = "Collusion";
  SecurityCaseType2["ExternalRequest"] = "ExternalRequest";
  SecurityCaseType2["Finance"] = "Finance";
  SecurityCaseType2["GeoLocation"] = "GeoLocation";
  SecurityCaseType2["Kyc"] = "Kyc";
  SecurityCaseType2["SharedInstance"] = "SharedInstance";
  SecurityCaseType2["Undefined"] = "Undefined";
  return SecurityCaseType2;
})(SecurityCaseType || {});
class SecurityCodeBusinessSwitch {
  __typename;
  p2p_transfer;
  withdrawal;
}
class SecurityCodeBusinessSwitchInput {
  p2p_transfer;
  withdrawal;
}
class SecurityCodeResetLog {
  __typename;
  id;
  last_reset_at;
  last_reset_by;
  last_status;
  reset_count;
  uid;
  username;
}
class SecurityCodeResetLogFilter {
  uid;
}
class SecurityCodeResetLogPage {
  __typename;
  items;
  total_count;
}
class SecurityCodeStatus {
  __typename;
  is_locked;
  is_set;
  uid;
}
class SecurityCodesConfig {
  __typename;
  business_switches;
  bypass_amount_limit;
  lock_duration_minutes;
  master_switch;
  max_failed_attempts;
  weak_code_list;
}
class SecurityCodesConfigInput {
  business_switches;
  bypass_amount_limit;
  lock_duration_minutes;
  master_switch;
  max_failed_attempts;
  weak_code_list;
}
class SecurityLimitHistory {
  __typename;
  currency;
  durationType;
  end_at;
  limit;
  limit_id;
  start_at;
  trigger_at;
  type;
}
class SecurityLimitHistoryInput {
  currency;
  durationType;
  end_at;
  limit;
  limit_id;
  start_at;
  trigger_at;
  type;
}
var SecurityLimitType = /* @__PURE__ */ ((SecurityLimitType2) => {
  SecurityLimitType2["Withdrawal"] = "WITHDRAWAL";
  return SecurityLimitType2;
})(SecurityLimitType || {});
var SecurityPunishmentStatus = /* @__PURE__ */ ((SecurityPunishmentStatus2) => {
  SecurityPunishmentStatus2["BanAccount"] = "BAN_ACCOUNT";
  SecurityPunishmentStatus2["ConfiscateBalance"] = "CONFISCATE_BALANCE";
  SecurityPunishmentStatus2["Nothing"] = "NOTHING";
  return SecurityPunishmentStatus2;
})(SecurityPunishmentStatus || {});
class ShareSummary {
  __typename;
  casino_share;
  global_spins_expected_ggr;
  mtt_ggr;
  plo_ggr;
  poker_share;
  sports_settled_bet;
  total_share;
}
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["Asc"] = "ASC";
  SortOrder2["Desc"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
class Sorting {
  order;
  sort;
}
class SourceOfFund {
  __typename;
  others_source_details;
  /** generated guid */
  source_id;
  type;
}
var SourceOfFundType = /* @__PURE__ */ ((SourceOfFundType2) => {
  SourceOfFundType2["BusinessEarnings"] = "BusinessEarnings";
  SourceOfFundType2["GamingWinnings"] = "GamingWinnings";
  SourceOfFundType2["Gift"] = "Gift";
  SourceOfFundType2["InvestmentEarnings"] = "InvestmentEarnings";
  SourceOfFundType2["Others"] = "Others";
  SourceOfFundType2["Salary"] = "Salary";
  return SourceOfFundType2;
})(SourceOfFundType || {});
class SportsSummary {
  __typename;
  sports_ggr;
  sports_settled_bet;
}
class StatusReasonFilter {
  reason;
  status;
}
class Subscription {
  __typename;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  accountVerificationAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  accountVerificationUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  backpackItemAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  backpackItemUpdated;
  beBonusAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  beBonusHistoryAdded;
  botGroupAdded;
  botGroupUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  eventLogAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  geoCheckSummaryAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  geoCheckSummaryUpdated;
  labelGroupAdded;
  labelGroupUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for manual credit cases under this license
   */
  manualCreditCaseAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for manual credit cases under this license
   */
  manualCreditCaseUpdated;
  marketingCodeAdded;
  marketingCodesDeleted;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  noteAdded;
  /**
   * Message should be sent for `upsertPageView` mutation if there is no item with passed `page_id` and `user_id` pair or its `last_opened_at` field is more
   *
   * Subscribe only for updates for passed page ids
   *
   * ### Policies: ###
   *
   * auth token contains `entity-all` or `entity-all:read`
   */
  pageViewAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  playerBonusAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  playerBonusUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  playerMessageAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  playerReferralAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  playerReferralUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  playerReferrerAdded;
  /**
   * subscription for referrer and his revenue share amount updates
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND `uid` param is linked to `sub` from auth token
   *
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  playerReferrerUpdated;
  playerRelationAdded;
  playerRelationDeleted;
  referralSettingsUpdated;
  rgLimitAdded;
  rgLimitUpdated;
  rgUserLimitsUpdated;
  userActionAdded;
  userGameUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  userGeoCheckAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  userKYCResults;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  userLoginHistory;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for players under this license
   */
  userProfileAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for players under this license
   */
  userProfileUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for players under this license
   */
  userProfileUpdatedV2;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for players under this license
   */
  userProfiles;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  userTransactionAdded;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  userTransactionUpdated;
  /**
   * ### License Policies: ###
   *
   * `license-kr`
   *
   * `license-ph`
   *
   * `license-mx`
   *
   * `license-cn`
   *
   * `license-cis`
   *
   * `license-curacao`
   *
   * `license-tobique`
   *
   * `license-anjouan`
   *
   * if auth token contains `<license policy>` OR `<license policy>:read` trigger for items that related to players under this license
   */
  userTransactions;
}
class SubscriptionFilter {
  field;
  value;
}
class SubscriptionListFilter {
  field;
  value;
}
class SyncKeycloakInput {
  is_agent;
  keycloak_enabled;
  keycloak_user_id;
}
class TextFilter {
  search_in;
  text;
}
class Timestamp {
  __typename;
  nanos;
  seconds;
}
class TimestampInput {
  nanos;
  seconds;
}
class TotalGgrSummary {
  __typename;
  ggr;
}
class Transaction {
  __typename;
  action_by_admin_id;
  amount;
  /** The BO user's ID was assigned to this transaction */
  assigned_user_id;
  brand;
  casino_coin_amount;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** if auth token contains `full-player` or `full-player:read` contact info is visible, else it is masked
   */
  contact;
  created_by_uid;
  currency;
  current_balance;
  current_casino_coin_balance;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** if auth token contains `full-player` or `full-player:read` email is visible, else it is masked
   */
  email;
  error_code;
  error_json;
  iso_alpha2_country_code;
  /** last reason specified when changing the Transaction status */
  last_reason;
  license_type;
  payment_method_description;
  payment_method_name;
  payment_option;
  payment_system_transaction_id;
  payment_system_uid;
  payment_vendor;
  previous_balance;
  previous_casino_coin_balance;
  ptp_counterparty_uid;
  /** reason change log, includes all statuses with reasons changes */
  reasons;
  referrer_player_id;
  register_marketing_code;
  /** Repeated attempts count. By default 0 */
  retries;
  /** time of the last retry attempt */
  retry_handled_at;
  retry_initiator_id;
  retry_resolve_ts;
  status_log;
  transaction_id;
  transaction_started_ts;
  transaction_status;
  transaction_updated_ts;
  turnover_rate;
  type;
  uid;
  user_labels;
  username;
  valid_bet;
  withdrawable_balance;
}
class TransactionAttemptsSummary {
  __typename;
  /** aggregation currency */
  currency;
  /** total failed amount in base currency */
  failed_amount;
  /** total number of failed transactions */
  failed_count;
  /** total pending amount in base currency */
  pending_amount;
  /** total number of pending transactions */
  pending_count;
  /** total rejected amount in base currency */
  rejected_amount;
  /** total number of rejected transactions */
  rejected_count;
  /** total successful amount in base currency */
  successful_amount;
  /** total number of successful transactions */
  successful_count;
}
class TransactionAttemptsSummaryInput {
  /** aggregation currency */
  currency;
  /** total failed amount in base currency */
  failed_amount;
  /** total number of failed transactions */
  failed_count;
  /** total pending amount in base currency */
  pending_amount;
  /** total number of pending transactions */
  pending_count;
  /** total rejected amount in base currency */
  rejected_amount;
  /** total number of rejected transactions */
  rejected_count;
  /** total successful amount in base currency */
  successful_amount;
  /** total number of successful transactions */
  successful_count;
}
class TransactionGroupSummary {
  __typename;
  category;
  /** aggregation currency */
  currency;
  /** total failed amount in base currency */
  failed_amount;
  /** total number of failed transactions */
  failed_count;
  group_name;
  payment_method;
  payment_method_description;
  /** total pending amount in base currency */
  pending_amount;
  /** total number of pending transactions */
  pending_count;
  /** total rejected amount in base currency */
  rejected_amount;
  /** total number of rejected transactions */
  rejected_count;
  /** total successful amount in base currency */
  successful_amount;
  /** total number of successful transactions */
  successful_count;
}
class TransactionGroupSummaryInput {
  category;
  /** aggregation currency */
  currency;
  /** total failed amount in base currency */
  failed_amount;
  /** total number of failed transactions */
  failed_count;
  group_name;
  payment_method;
  payment_method_description;
  /** total pending amount in base currency */
  pending_amount;
  /** total number of pending transactions */
  pending_count;
  /** total rejected amount in base currency */
  rejected_amount;
  /** total number of rejected transactions */
  rejected_count;
  /** total successful amount in base currency */
  successful_amount;
  /** total number of successful transactions */
  successful_count;
}
class TransactionHistory {
  __typename;
  logged_at;
  status;
}
class TransactionHistoryInput {
  logged_at;
  status;
}
class TransactionInput {
  action_by_admin_id;
  amount;
  assigned_user_id;
  brand;
  casino_coin_amount;
  contact;
  created_by_uid;
  currency;
  current_balance;
  current_casino_coin_balance;
  email;
  error_code;
  error_json;
  iso_alpha2_country_code;
  last_reason;
  license_type;
  payment_method_description;
  payment_method_name;
  payment_option;
  payment_system_transaction_id;
  payment_system_uid;
  payment_vendor;
  previous_balance;
  previous_casino_coin_balance;
  ptp_counterparty_uid;
  reasons;
  referrer_player_id;
  register_marketing_code;
  retries;
  retry_handled_at;
  retry_initiator_id;
  retry_resolve_ts;
  status_log;
  transaction_id;
  transaction_started_ts;
  transaction_status;
  transaction_updated_ts;
  turnover_rate;
  type;
  uid;
  user_labels;
  username;
  valid_bet;
  withdrawable_balance;
}
var TransactionStatus = /* @__PURE__ */ ((TransactionStatus2) => {
  TransactionStatus2["Cancelled"] = "Cancelled";
  TransactionStatus2["Deleted"] = "Deleted";
  TransactionStatus2["Failed"] = "Failed";
  TransactionStatus2["InProgress"] = "InProgress";
  TransactionStatus2["OnHoldPayment"] = "OnHoldPayment";
  TransactionStatus2["OnHoldRisk"] = "OnHoldRisk";
  TransactionStatus2["Pending"] = "Pending";
  TransactionStatus2["Rejected"] = "Rejected";
  TransactionStatus2["RiskAuthorized"] = "RiskAuthorized";
  TransactionStatus2["Succeeded"] = "Succeeded";
  return TransactionStatus2;
})(TransactionStatus || {});
class TransactionSummary {
  __typename;
  per_method;
  total;
}
class TransactionSummaryInput {
  per_method;
  total;
}
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["Bonus"] = "BONUS";
  TransactionType2["BuyIn"] = "BUY_IN";
  TransactionType2["BuyOut"] = "BUY_OUT";
  TransactionType2["CasinoFreeSpinPayout"] = "CASINO_FREE_SPIN_PAYOUT";
  TransactionType2["CasinoFreeSpinPayoutRefund"] = "CASINO_FREE_SPIN_PAYOUT_REFUND";
  TransactionType2["CasinoFreeSpinWager"] = "CASINO_FREE_SPIN_WAGER";
  TransactionType2["CasinoFreeSpinWagerRefund"] = "CASINO_FREE_SPIN_WAGER_REFUND";
  TransactionType2["CasinoPayout"] = "CASINO_PAYOUT";
  TransactionType2["CasinoPayoutRefund"] = "CASINO_PAYOUT_REFUND";
  TransactionType2["CasinoWager"] = "CASINO_WAGER";
  TransactionType2["CasinoWagerRefund"] = "CASINO_WAGER_REFUND";
  TransactionType2["Chargeback"] = "CHARGEBACK";
  TransactionType2["Credit"] = "CREDIT";
  TransactionType2["Debit"] = "DEBIT";
  TransactionType2["Deposit"] = "DEPOSIT";
  TransactionType2["Fee"] = "FEE";
  TransactionType2["FeeReverse"] = "FEE_REVERSE";
  TransactionType2["LiveEventBuyIn"] = "LIVE_EVENT_BUY_IN";
  TransactionType2["MttCredit"] = "MTT_CREDIT";
  TransactionType2["MttDebit"] = "MTT_DEBIT";
  TransactionType2["P2PTransferCredit"] = "P2P_TRANSFER_CREDIT";
  TransactionType2["P2PTransferDebit"] = "P2P_TRANSFER_DEBIT";
  TransactionType2["Payin"] = "PAYIN";
  TransactionType2["Payout"] = "PAYOUT";
  TransactionType2["PayoutReturn"] = "PAYOUT_RETURN";
  TransactionType2["PokerAddonCredit"] = "POKER_ADDON_CREDIT";
  TransactionType2["PokerAddonDebit"] = "POKER_ADDON_DEBIT";
  TransactionType2["PokerFlipsPayout"] = "POKER_FLIPS_PAYOUT";
  TransactionType2["PokerFlipsWager"] = "POKER_FLIPS_WAGER";
  TransactionType2["Refund"] = "REFUND";
  TransactionType2["Release"] = "RELEASE";
  TransactionType2["Reserve"] = "RESERVE";
  TransactionType2["RevenueShare"] = "REVENUE_SHARE";
  TransactionType2["Reverse"] = "REVERSE";
  TransactionType2["SportsBetSettlement"] = "SPORTS_BET_SETTLEMENT";
  TransactionType2["SportsBuyin"] = "SPORTS_BUYIN";
  TransactionType2["SportsBuyout"] = "SPORTS_BUYOUT";
  TransactionType2["Withdrawal"] = "WITHDRAWAL";
  return TransactionType2;
})(TransactionType || {});
class TriggerOutput {
  __typename;
  error;
  player_bonus;
}
class TurnoverConfig {
  __typename;
  countries;
  id;
  /** sortable */
  license;
  /** sortable */
  scope_type;
  /** sortable */
  turnover_rate;
  /** sortable */
  updated_at;
  /** sortable */
  updated_by_uid;
}
class TurnoverConfigFilter {
  /** search by country. Result should include both license-level settings and country-level settings where the country included */
  countries;
  /** search by license. Result should include both license-level settings and country-level settings where country from the license included */
  licenses;
  scope_types;
}
class TurnoverConfigPage {
  __typename;
  items;
  total;
}
class UpdateFailureTransactionInput {
  error_code;
  error_json;
  failure_ts;
  order_id;
  order_status;
  product;
  resolve_ts;
  retries;
  retry_handled_at;
  retry_initiator_id;
  system;
  type;
  uid;
}
class UpdateTurnoverConfig {
  countries;
  id;
  turnover_rate;
}
class UploadedDocumentFilter {
  doc_type;
  status;
  uploaded_ts;
}
class UploadedDocumentPage {
  __typename;
  items;
  total_count;
}
class User2FaInput {
  is_enabled;
  uid;
}
var UserAccountStatus = /* @__PURE__ */ ((UserAccountStatus2) => {
  UserAccountStatus2["Active"] = "ACTIVE";
  UserAccountStatus2["Blocked"] = "BLOCKED";
  UserAccountStatus2["Closed"] = "CLOSED";
  UserAccountStatus2["Deregistered"] = "DEREGISTERED";
  UserAccountStatus2["Dormant"] = "DORMANT";
  UserAccountStatus2["Locked"] = "LOCKED";
  UserAccountStatus2["Pending"] = "PENDING";
  return UserAccountStatus2;
})(UserAccountStatus || {});
class UserAction {
  __typename;
  action_by_uid;
  action_type;
  id;
  new_value;
  player_uid;
  prev_value;
  trigger_at;
}
class UserActionHistoryPage {
  __typename;
  items;
  total_count;
}
class UserActionInput {
  action;
  action_by_uid;
  action_type;
  id;
  new_value;
  player_uid;
  trigger_at;
}
class UserActivitySummary {
  __typename;
  average_bet;
  average_poker_buy_in;
  /** 5 most Casino games played type */
  casino_favorite_games;
  /** days from last real money play */
  days_from_last_active;
  /** last played game */
  last_played_game;
  /** 5 most Poker games played type */
  poker_favorite_games;
  /** (VIP) as per existing flags NVIP, Level 1, Level 2, etc */
  skill_flag;
  /** 5 most Slot games played type */
  slot_favorite_games;
}
class UserAddressInfo {
  __typename;
  address;
  city;
  country;
  country_info;
  post_code;
  state;
  street;
}
class UserAddressInfoInput {
  address;
  city;
  country;
  country_info;
  post_code;
  state;
  street;
}
class UserAssignInput {
  /** unique identifier to guarantee operation idempotence; optional for backward compatibility */
  id;
  user_id;
}
class UserBetInput {
  at_ts;
  bet_return;
  bet_size;
  business_pool;
  game_type;
  game_uuid;
  room_id;
  uid;
}
class UserBiggestValues {
  __typename;
  business_pool;
  net_loss;
  num_sessions;
  single_bet;
  total_bet;
  uid;
}
class UserBiggestValuesInput {
  business_pool;
  net_loss;
  num_sessions;
  single_bet;
  total_bet;
  uid;
}
class UserBlackList {
  __typename;
  blacklisted;
  deposit_threshold;
  items;
}
class UserBlackListInput {
  blacklisted;
  deposit_threshold;
  items;
}
var UserBusinessPool = /* @__PURE__ */ ((UserBusinessPool2) => {
  UserBusinessPool2["Pkw"] = "PKW";
  UserBusinessPool2["Wpk"] = "WPK";
  return UserBusinessPool2;
})(UserBusinessPool || {});
class UserChallengeQuestionInput {
  is_enabled;
  uid;
}
class UserClub {
  __typename;
  club_id;
  uid;
}
class UserClubsFilter {
  text;
}
class UserClubsPage {
  __typename;
  items;
  total_count;
}
class UserContactInfo {
  __typename;
  email;
  mobile;
  verified_email;
  verified_mobile;
}
class UserContactInfoInput {
  email;
  mobile;
  verified_email;
  verified_mobile;
}
class UserGame {
  __typename;
  action;
  community_cards;
  currency;
  final_balance;
  game_id;
  game_type;
  initial_balance;
  private_cards;
  result;
  round;
  started_at;
  total_pot;
  uid;
  username;
  winner_username;
}
class UserGameInput {
  action;
  community_cards;
  currency;
  final_balance;
  game_id;
  game_type;
  initial_balance;
  private_cards;
  result;
  round;
  started_at;
  total_pot;
  uid;
  username;
  winner_username;
}
class UserGamePage {
  __typename;
  items;
  total_count;
}
class UserIdentityInfo {
  __typename;
  last_ssn_digits;
}
class UserIdentityInfoInput {
  last_ssn_digits;
}
class UserIdentityInput {
  address;
  birthday;
  first_name;
  gender;
  last_name;
  last_ssn_digits;
  nickname;
  platform;
  post_code;
  uid;
}
class UserKycPage {
  __typename;
  items;
  total_count;
}
class UserLabel {
  __typename;
  group;
  id;
  name;
}
class UserLabelGroup {
  __typename;
  color;
  id;
  name;
  source_type;
}
class UserLabelGroupInput {
  color;
  id;
  name;
  source_type;
}
class UserLabelInput {
  group;
  id;
  name;
}
class UserLicenseInput {
  country;
  license_type;
  state;
  uid;
}
class UserLogin {
  __typename;
  connection_type;
  correlation_id;
  current_balance;
  device;
  ip;
  ip_quality_score;
  isp;
  language;
  location;
  logged_at_ts;
  login_status;
  login_type;
  logout_info;
  recaptcha_reasons;
  recaptcha_score;
  session_id;
  uid;
  username;
  vpn;
}
class UserLoginFilter {
  logged_at_ts;
  logged_out_at_ts;
  players_groups;
  text;
}
class UserLoginInput {
  connection_type;
  correlation_id;
  current_balance;
  device;
  ip;
  ip_quality_score;
  isp;
  language;
  location;
  logged_at_ts;
  login_status;
  login_type;
  recaptcha_reasons;
  recaptcha_score;
  session_id;
  uid;
  username;
  vpn;
}
class UserLoginPage {
  __typename;
  items;
  total_count;
}
class UserLogout {
  __typename;
  logged_out_at_ts;
  reason;
  session_id;
  uid;
}
class UserLogoutInput {
  logged_out_at_ts;
  reason;
  session_id;
  uid;
}
class UserMarketingInfo {
  __typename;
  register_marketing_code;
  register_player_bonus;
}
class UserMarketingInfoInput {
  register_marketing_code;
  register_player_bonus;
}
class UserNetworkProfile {
  __typename;
  platform;
  uid;
}
class UserNetworkProfileInput {
  platform;
  uid;
}
class UserPage {
  __typename;
  items;
  total_count;
}
class UserProfile {
  __typename;
  aal;
  /**
   * shows if player can login into the app
   *
   * default value: ACTIVE
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is an agent which called the query OR his direct referee OR his downstream referee)
   */
  account_status;
  /**
   * contains information about state, city and home address
   *
   * ### Policies: ###
   *
   * auth token contains `entity-all:read`
   */
  address;
  affiliate;
  agent_info;
  aml_labels;
  avg_binary_mistake_score;
  bb_100;
  birthday;
  black_list;
  blocked_stakes_access;
  brand;
  business_pool;
  /**
   * shows if player can access casino games
   *
   * default value: UNLOCKED
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is an agent which called the query OR his direct referee OR his downstream referee)
   */
  casino_status;
  /**
   * Shows in which channel player is
   *
   * default value: OFFICIAL
   */
  channel;
  club;
  /**
   * ### Policies: ###
   *
   * ** For all users: ** if auth token contains `full-player` or `full-player:read` contact info is visible, else it is masked
   */
  contact;
  countries;
  date_of_joining;
  deposit_status;
  devices;
  distance_score;
  evidence;
  finance;
  first_name;
  friend_groups;
  gender;
  identity_info;
  ip_addresses;
  ip_quality_score;
  keycloak_enabled;
  kyc_action;
  labels;
  language;
  last_name;
  last_region;
  latest_kyc;
  latest_login;
  license_type;
  lobby_access_status;
  marketing_info;
  most_played_stake;
  networks;
  nickname;
  num_linked_bots_by_bank_card;
  num_linked_bots_by_bank_card_name;
  num_linked_bots_by_devices;
  num_linked_bots_by_ips;
  num_linked_bots_by_subnets;
  num_linked_members_by_bank_card;
  num_linked_members_by_bank_card_name;
  num_linked_members_by_devices;
  num_linked_members_by_subnets;
  p2p_override_status;
  p2p_status;
  p2p_transfer_status;
  platform;
  players_groups;
  pool_id;
  punishment_status;
  recaptcha_score;
  referral;
  region_player_info;
  remote_logins;
  security;
  security_cases;
  security_settings;
  /**
   * shows sportsbook transactions is available for player
   *
   * default value: UNLOCKED
   *
   * ### Policies: ###
   *
   * ** For all users: ** auth token contains `entity-all:read`
   *
   * ** For agents: ** auth token contains `agent:read` AND (player is an agent which called the query OR his direct referee OR his downstream referee)
   */
  sportsbook_status;
  uid;
  username;
  verification_info;
  vpn;
  /**
   * Shows if the player is whitelisted
   *
   * default value: DISABLED
   */
  whitelist_status;
  win_total;
  withdrawal_limits;
  withdrawal_status;
}
class UserProfileFilter {
  aal;
  account_status;
  birthday;
  brand;
  casino_ggr;
  channel;
  date_of_joining;
  deposit_status;
  deposit_total;
  is_agent;
  kyc_status;
  license_type;
  /**
   * returns all values where at least one of fields from array is not empty
   *
   * For example, `["agent_info.bo_agent_id", "referral.inviting_user_id"]` returns items where `agent_info.bo_agent_id` or `referral.inviting_user_id` is not empty
   */
  not_empty;
  p2p_override_status;
  p2p_status;
  players_groups;
  poker_ggr;
  referrer;
  security_cases;
  sports_ggr;
  text;
  whitelist_status;
  withdrawal_status;
  withdrawal_total;
}
class UserProfileInput {
  account_status;
  account_verification_status;
  action_by_uid;
  address;
  affiliate;
  agent_info;
  avg_binary_mistake_score;
  balance;
  bb_100;
  birthday;
  black_list;
  blocked_stakes_access;
  brand;
  business_pool;
  club;
  contact;
  countries;
  date_of_joining;
  deposit_status;
  devices;
  distance_score;
  evidence;
  finance;
  first_name;
  friend_groups;
  gender;
  identity_info;
  ip_addresses;
  ip_quality_score;
  keycloak_enabled;
  kyc_action;
  kyc_status;
  language;
  last_name;
  last_region;
  latest_kyc;
  latest_login;
  license_type;
  lobby_access_status;
  marketing_info;
  most_played_stake;
  networks;
  nickname;
  num_linked_bots_by_bank_card;
  num_linked_bots_by_bank_card_name;
  num_linked_bots_by_devices;
  num_linked_bots_by_ips;
  num_linked_bots_by_subnets;
  num_linked_members_by_bank_card;
  num_linked_members_by_bank_card_name;
  num_linked_members_by_devices;
  num_linked_members_by_subnets;
  p2p_override_status;
  p2p_status;
  p2p_transfer_status;
  pii_manual;
  platform;
  players_groups;
  pool_id;
  punishment_status;
  recaptcha_score;
  referral;
  region_player_info;
  remote_logins;
  security;
  security_cases;
  security_settings;
  uid;
  username;
  verification_info;
  vpn;
  win_total;
  withdrawal_limits;
  withdrawal_status;
}
class UserRgLimitsPage {
  __typename;
  items;
  total_count;
}
class UserReCaptchaScore {
  __typename;
  reasons;
  score;
  uid;
  updated_at_ts;
}
class UserReCaptchaScoreFilter {
  score;
  text;
  updated_at_ts;
}
class UserReCaptchaScoreInput {
  reasons;
  score;
  uid;
  updated_at_ts;
}
class UserReCaptchaScorePage {
  __typename;
  items;
  total_count;
}
class UserReputationScore {
  __typename;
  latest_time;
  login_name;
  plat;
  reputation;
  update_time;
}
class UserReputationScoreFilter {
  latest_time;
  update_time;
}
class UserReputationScoreInput {
  latest_time;
  login_name;
  plat;
  reputation;
  update_time;
}
class UserReputationScorePage {
  __typename;
  items;
  total_count;
}
class UserSecuritySettings {
  __typename;
  is_2fa_enabled;
  is_challenge_questions_enabled;
}
class UserSecuritySettingsInput {
  is_2fa_enabled;
  is_challenge_questions_enabled;
}
class UserStatistics {
  __typename;
  AF;
  AF_flop;
  AF_river;
  AF_turn;
  AFq;
  AFq_flop;
  AFq_river;
  AFq_turn;
  BB_100;
  PFR;
  RFI;
  VPIP;
  VS_three_bet_call;
  VS_three_bet_raise;
  WSD;
  WTSD;
  WWSF;
  buy_insurance_times;
  cbet_ip;
  cbet_muti;
  cbet_oop;
  cold_call;
  created_at;
  curdrawin;
  drawin;
  flop_cb_vs_raise_call;
  flop_cb_vs_raise_fold;
  flop_cb_vs_raise_raise;
  flop_cbet;
  flop_donk_bet;
  flop_donk_bet_vs_raise_call;
  flop_donk_bet_vs_raise_fold;
  flop_donk_bet_vs_raise_raise;
  flop_vs_donk_bet_call;
  flop_vs_donk_bet_fold;
  flop_vs_donk_bet_raise;
  game;
  gametype;
  insurance_total;
  insurancebetamount;
  insurancewinbet;
  jack_total;
  jackwinbet;
  limp;
  openfold;
  openlimp;
  player;
  playerid;
  poker_total;
  rfi_four_bet;
  river_cb_vs_raise_call;
  river_cb_vs_raise_fold;
  river_cb_vs_raise_raise;
  river_cbet;
  river_donk_bet;
  river_donk_bet_vs_raise_call;
  river_donk_bet_vs_raise_fold;
  river_donk_bet_vs_raise_raise;
  river_vs_donk_bet_call;
  river_vs_donk_bet_fold;
  river_vs_donk_bet_raise;
  seat;
  squeeze;
  stake;
  steal;
  three_bet_call;
  three_bet_fold;
  three_bet_raise;
  turn_cb_vs_raise_call;
  turn_cb_vs_raise_fold;
  turn_cb_vs_raise_raise;
  turn_cbet;
  turn_donk_bet;
  turn_donk_bet_vs_raise_call;
  turn_donk_bet_vs_raise_fold;
  turn_donk_bet_vs_raise_raise;
  turn_vs_donk_bet_call;
  turn_vs_donk_bet_fold;
  turn_vs_donk_bet_raise;
  vs_three_bet_fold;
  wintotal;
}
class UserStatisticsFilter {
  created_at;
  players_group;
  text;
}
var UserStatisticsGameType = /* @__PURE__ */ ((UserStatisticsGameType2) => {
  UserStatisticsGameType2["Nl"] = "NL";
  UserStatisticsGameType2["Plo"] = "PLO";
  UserStatisticsGameType2["Sd"] = "SD";
  return UserStatisticsGameType2;
})(UserStatisticsGameType || {});
class UserStatisticsInput {
  AF;
  AF_flop;
  AF_river;
  AF_turn;
  AFq;
  AFq_flop;
  AFq_river;
  AFq_turn;
  BB_100;
  PFR;
  RFI;
  VPIP;
  VS_three_bet_call;
  VS_three_bet_raise;
  WSD;
  WTSD;
  WWSF;
  buy_insurance_times;
  cbet_ip;
  cbet_muti;
  cbet_oop;
  cold_call;
  created_at;
  curdrawin;
  drawin;
  flop_cb_vs_raise_call;
  flop_cb_vs_raise_fold;
  flop_cb_vs_raise_raise;
  flop_cbet;
  flop_donk_bet;
  flop_donk_bet_vs_raise_call;
  flop_donk_bet_vs_raise_fold;
  flop_donk_bet_vs_raise_raise;
  flop_vs_donk_bet_call;
  flop_vs_donk_bet_fold;
  flop_vs_donk_bet_raise;
  game;
  gametype;
  insurance_total;
  insurancebetamount;
  insurancewinbet;
  jack_total;
  jackwinbet;
  limp;
  openfold;
  openlimp;
  player;
  playerid;
  poker_total;
  rfi_four_bet;
  river_cb_vs_raise_call;
  river_cb_vs_raise_fold;
  river_cb_vs_raise_raise;
  river_cbet;
  river_donk_bet;
  river_donk_bet_vs_raise_call;
  river_donk_bet_vs_raise_fold;
  river_donk_bet_vs_raise_raise;
  river_vs_donk_bet_call;
  river_vs_donk_bet_fold;
  river_vs_donk_bet_raise;
  seat;
  squeeze;
  stake;
  steal;
  three_bet_call;
  three_bet_fold;
  three_bet_raise;
  turn_cb_vs_raise_call;
  turn_cb_vs_raise_fold;
  turn_cb_vs_raise_raise;
  turn_cbet;
  turn_donk_bet;
  turn_donk_bet_vs_raise_call;
  turn_donk_bet_vs_raise_fold;
  turn_donk_bet_vs_raise_raise;
  turn_vs_donk_bet_call;
  turn_vs_donk_bet_fold;
  turn_vs_donk_bet_raise;
  vs_three_bet_fold;
  wintotal;
}
class UserStatisticsPage {
  __typename;
  items;
  total_count;
}
class UserTransactionFilter {
  account_status;
  account_verification_status;
  amount;
  brand;
  iso_alpha2_country_code;
  /** Transaction filter for the latest status change reasons */
  last_reason;
  license_type;
  payment_option;
  /** Transaction filter by reason code, includes all statuses with reasons changes */
  reason_code;
  referrer;
  show_total_amount;
  /** AND filter combining status and reason */
  status_reason;
  text;
  transaction_started_ts;
  transaction_status;
  transaction_types;
  transaction_updated_ts;
  transaction_year;
}
class UserTransactionPage {
  __typename;
  items;
  total_amount;
  total_count;
}
class ValidationResult {
  __typename;
  message;
  status;
}
class VerificationCode {
  __typename;
  /** Auth token should have `otp:read` policy to return the value */
  code;
  code_type;
  confirmed_date;
  created_date;
  /** should be masked if user doesn't have `full-player:read` policy */
  email;
  is_confirmed;
  is_expired;
  /** should be masked if user doesn't have `full-player:read` policy */
  mobile;
  uid;
  username;
}
class VerificationCodeFilter {
  email;
  phone;
  statuses;
  types;
  uid;
  username;
}
class VerificationCodePage {
  __typename;
  items;
  total_count;
}
var VerificationCodeStatus = /* @__PURE__ */ ((VerificationCodeStatus2) => {
  VerificationCodeStatus2["Unused"] = "Unused";
  VerificationCodeStatus2["Used"] = "Used";
  return VerificationCodeStatus2;
})(VerificationCodeStatus || {});
var VerificationCodeType = /* @__PURE__ */ ((VerificationCodeType2) => {
  VerificationCodeType2["PasswordChange"] = "PasswordChange";
  VerificationCodeType2["PasswordRecovery"] = "PasswordRecovery";
  return VerificationCodeType2;
})(VerificationCodeType || {});
class VerifiedContactInput {
  email;
  phone;
}
class WeeklySummaryExport {
  __typename;
  aal;
  agent_uid;
  comments;
  direction;
  reason_codes;
  reference;
  turnover_rate;
  weekly_actually_paid;
}
class WeeklySummaryExportPage {
  __typename;
  items;
  last_updated;
  total_count;
}
class WhiteListInput {
  uid;
  /** unique identifier to guarantee operation idempotence; optional for backward compatibility */
  whitelist_status;
}
var Workspace = /* @__PURE__ */ ((Workspace2) => {
  Workspace2["CustomerSupport"] = "CustomerSupport";
  Workspace2["Fraud"] = "Fraud";
  Workspace2["Global"] = "Global";
  Workspace2["Kyc"] = "KYC";
  Workspace2["Payment"] = "Payment";
  Workspace2["Security"] = "Security";
  return Workspace2;
})(Workspace || {});
export {
  AccountVerification,
  AccountVerificationFilter,
  AccountVerificationInput,
  AccountVerificationPage,
  AccountVerificationStatus,
  AccountVerificationStatusLog,
  AccountVerificationStatusLogInput,
  AccountVerificationType,
  ActionFilter,
  ActionType,
  ActiveAccountVerification,
  ActiveAccountVerificationInput,
  AddSourceOfFundsInput,
  AddUserLabelInput,
  AdjustAgentDebtInput,
  AffiliateInput,
  Affiliates,
  AffiliatesInput,
  AgentCommissionSubtypes,
  AgentCommissionSubtypesHistory,
  AgentCommissionSubtypesInput,
  AgentInfo,
  AgentInfoInput,
  AgentNegativeCarryoverReport,
  AgentNegativeCarryoverReportPage,
  AgentPathStatistics,
  AgentPathStatisticsPage,
  AgentPlayerReportVersion,
  AgentPlayerReporting,
  AgentPlayerReportingFilter,
  AgentPlayerReportingFilterVn,
  AgentPlayerReportingKr,
  AgentPlayerReportingKrPage,
  AgentPlayerReportingKrSummary,
  AgentPlayerReportingPage,
  AgentPlayerReportingSummary,
  AgentPlayerReportingV2,
  AgentPlayerReportingV2Page,
  AgentPlayerReportingV2Summary,
  AgentPlayerReportingVn,
  AgentPlayerReportingVnPage,
  AgentPlayerReportingVnSummary,
  AgentProfileFilter,
  AgentRefereeRevenueReport,
  AgentRefereeRevenueReportFilter,
  AgentRefereeRevenueReportPage,
  AgentRevenueShareInput,
  AgentRevenueShareTier,
  AgentRevenueShareWeeklyReport,
  AgentRevenueShareWeeklyReportFilter,
  AgentRevenueShareWeeklyReportPage,
  AggregatedFinanceSummariesFilterInput,
  AggregatedFinanceSummariesPage,
  AggregatedFinanceSummary,
  AggregatedFinanceSummaryFilterInput,
  AggregatedFinanceSummaryInput,
  AmlLabel,
  Attachment,
  AttachmentInput,
  AutoWithdrawalRulesData,
  BackpackItem,
  BackpackItemInput,
  BackpackItemLabel,
  BackpackItemSource,
  BackpackItemStatus,
  BackpackItemsFilter,
  BackpackItemsPage,
  BettingRound,
  BlackListItem,
  BlackListItemInput,
  BlackListItemType,
  BlacklistIp,
  BlacklistIpPage,
  BoUser,
  BoUserAttributes,
  BoUserAttributesInput,
  BoUserCredentials,
  BoUserCredentialsInput,
  BoUserFilter,
  BoUserInput,
  BoUserPage,
  BoUserSettings,
  BonusCasino,
  BonusCasinoInput,
  BonusCasinoSourceType,
  BonusCodeDetails,
  BonusCodeFilterInput,
  BonusCodeHistory,
  BonusCodeHistoryFilterInput,
  BonusCodeHistoryInput,
  BonusCodeHistoryPage,
  BonusCodeInput,
  BonusCodePage,
  BonusCodeUpsert,
  BonusCostSummary,
  BonusCreditType,
  BonusMeta,
  BonusMetaInput,
  BonusReleaseMechanism,
  BonusReleaseMetric,
  BonusReleaseRatio,
  BonusReleaseRatioInput,
  BonusReleaseRatioType,
  BonusStatus,
  BonusSummary,
  BonusToCredit,
  BonusType,
  BotDetectionActionType,
  BotDetectionPlayersGroup,
  BotGroup,
  BotGroupFilter,
  BotGroupInput,
  BotGroupPage,
  Brand,
  BulkItem,
  BulkItemDataInput,
  BulkItemInput,
  BulkItemStatus,
  BulkMutationInput,
  BulkMutationResponse,
  BulkOperationFilterInput,
  BulkOperationResult,
  BulkOperationResultFilter,
  BulkOperationResultPage,
  BulkOperationStatus,
  BulkP2PPlayerSettingsInput,
  BulkP2PPlayerSettingsV2Input,
  CardItem,
  CardItemInput,
  CardNumber,
  CardSuite,
  CasinoError,
  CasinoProviderName,
  CasinoResponse,
  CasinoSummary,
  CasinoTriggerInput,
  Channel,
  Club,
  ClubsFilter,
  ClubsPage,
  CommentTargetType,
  CommissionSubTypes,
  CommissionSubTypesHistorical,
  ComplianceResultInput,
  CountryInfo,
  CountryInfoInput,
  CountryLevelReport,
  CountryLevelReportPage,
  CountryLevelReportSummary,
  CountryLevelReportingFilter,
  CreateRepaymentLogInput,
  CreateTurnoverConfig,
  DashboardUrl,
  DateRange,
  DebtAdjustmentType,
  DebtResponsibleMasterAgent,
  DebtResponsibleMasterAgents,
  DebtResponsibleMasterAgentsFilter,
  DebtResponsibleMasterAgentsPage,
  DebtTransferLog,
  DebtTransferLogsFilter,
  DebtTransferLogsPage,
  DeductionSummary,
  DeleteP2PGlobalSettingsInput,
  DeleteP2PGlobalSettingsV2Input,
  DeleteTurnoverConfig,
  DeleteUserLabelInput,
  Device,
  DeviceInput,
  EditRepaymentLogInput,
  EmbeddedDashboardType,
  Entity,
  EntityFilterType,
  EntityInput,
  EntityRelationType,
  EntityType,
  EventInitiator,
  EventLogFilter,
  EventLogRecord,
  EventLogRecordInput,
  EventLogRecordPage,
  FailedOrder,
  FailedOrderCategory,
  FailedOrderFilter,
  FailedOrderPage,
  FailedOrderStatus,
  FailureTransactionInput,
  FeatureAccessLockInput,
  FeatureAccessStatus,
  FlashCampaign,
  FlashCampaignFilter,
  FlashCampaignInput,
  FlashCampaignPage,
  FlashCampaignPeriodicity,
  FlashCampaignStatus,
  FriendGroup,
  FriendGroupFilter,
  FriendGroupInput,
  FriendGroupPage,
  FriendsGroupUsersActionType,
  GameHistoryFilter,
  GameMode,
  GameTable,
  GameTableInput,
  GameType,
  Gender,
  GeoCheck,
  GeoCheckEventSource,
  GeoCheckFilter,
  GeoCheckInput,
  GeoCheckPage,
  GeoCheckStatus,
  GeoCheckSummary,
  GeoCheckSummaryInput,
  Ggr,
  GgrInput,
  GgrLifetime,
  GgrSummary,
  GlobalSearchFilter,
  GlobalSearchRecord,
  GlobalSearchSource,
  GlobalSpinsSummary,
  Group,
  GroupInput,
  GroupPage,
  InitKycInput,
  IpBlacklistFilterInput,
  IsPro,
  JumioDocumentSubType,
  JumioDocumentType,
  JumioLocation,
  JumioLocationInput,
  KeycloakLog,
  KeycloakLogsFilter,
  KeycloakLogsPage,
  KycCheckResults,
  KycCheckResultsFilter,
  KycCheckResultsInput,
  KycCheckType,
  KycDocument,
  KycDocumentInput,
  KycReasonCode,
  KycStatus,
  KycStatusInput,
  Label,
  LabelGroup,
  LabelGroupFilter,
  LabelGroupInput,
  LabelGroupPage,
  LabelGroupSourceType,
  LabelInput,
  LimitDurationType,
  Location,
  LocationInput,
  LoginStatus,
  LoginType,
  LogoutInfo,
  ManualCreditApprover,
  ManualCreditApproverFilter,
  ManualCreditApproverInput,
  ManualCreditApproverPage,
  ManualCreditCase,
  ManualCreditCaseFilter,
  ManualCreditCaseInput,
  ManualCreditCasePage,
  ManualCreditCaseStatus,
  ManualCreditCaseStatusUpdateInput,
  ManualTransaction,
  ManualTransactionInput,
  MarketingCode,
  MarketingCodeDeleteInput,
  MarketingCodeFilterInput,
  MarketingCodeInput,
  MarketingCodesPage,
  MasterAgent,
  Mutation,
  NgrSummary,
  Note,
  NoteInput,
  NoteType,
  NotesFilterInput,
  NotesFilterType,
  NotesPage,
  NumRange,
  OperationType,
  OtherSummary,
  P2PGlobalConfigsFilter,
  P2PGlobalSettings,
  P2PGlobalSettingsInput,
  P2PGlobalSettingsPage,
  P2PGlobalSettingsV2Input,
  P2PLimits,
  P2PLimitsInput,
  P2PLog,
  P2PLogFilter,
  P2PLogInput,
  P2PLogPage,
  P2PLogStatus,
  P2PPersonalLimits,
  P2PPersonalLimitsInput,
  P2PPlayerSettingsInput,
  P2PPlayerSettingsV2Input,
  P2PRankingReport,
  P2PRankingReportFilter,
  P2PRankingReportPage,
  P2PSender,
  P2PTransferInput,
  P2PTransferResponse,
  PageView,
  PageViewFilter,
  PageViewInput,
  PaymentDetailsInput,
  PaymentOption,
  PaymentStatus,
  PaymentSystem,
  PaymentVendor,
  PayoutReport,
  PayoutReportsFilter,
  PayoutReportsPage,
  PhoneNumber,
  PhoneNumberInput,
  Platform,
  PlayerActivitySummary,
  PlayerBalanceSummary,
  PlayerBalanceSummaryInput,
  PlayerBonus,
  PlayerBonusInput,
  PlayerBonusStatus,
  PlayerBonusTriggerInput,
  PlayerBonusTriggerMetaInput,
  PlayerBonusesFilter,
  PlayerBonusesPage,
  PlayerCashierOtp,
  PlayerCashierOtpStatus,
  PlayerDepositSummary,
  PlayerDepositSummaryInput,
  PlayerEcologySummary,
  PlayerEcologyWeeklyReport,
  PlayerEcologyWeeklyReportFilter,
  PlayerEcologyWeeklyReportPage,
  PlayerFinanceSummary,
  PlayerFinanceSummaryInput,
  PlayerGamesSummary,
  PlayerLoginOtp,
  PlayerLoginOtpStatus,
  PlayerMessage,
  PlayerMessageFilterInput,
  PlayerMessageInput,
  PlayerMessageMailType,
  PlayerMessageSource,
  PlayerMessagesPage,
  PlayerReferral,
  PlayerReferralInput,
  PlayerReferralsFilter,
  PlayerReferralsPage,
  PlayerReferrerSummary,
  PlayerSecuritySummary,
  PlayerSecuritySummaryInput,
  PlayerSkill,
  PlayerSkillCustomLabel,
  PlayerSkillInput,
  PlayerSkillLabel,
  PlayerSourceOfFunds,
  PlayerUidInput,
  PlayerVerificationInfo,
  PlayerVerificationInfoInput,
  PlayerVerificationStatus,
  PlayerWithdrawalSummary,
  PlayerWithdrawalSummaryInput,
  PlayersGroup,
  PlayersRelation,
  PlayersRelationFilter,
  PlayersRelationInput,
  PlayersRelationPage,
  PlayersRelationType,
  PokerMttSummary,
  PokerNlheSummary,
  PokerPloSummary,
  PokerSummary,
  PrizeDistribution,
  PrizeDistributionInput,
  PrizePool,
  PrizePoolInput,
  PrizePoolTotals,
  PrizePoolTotalsInput,
  ProPlayer,
  ProPlayerFilter,
  ProPlayerPage,
  ProSummary,
  Query,
  Reason,
  ReasonCode,
  ReasonInput,
  ReasonType,
  RefereeType,
  ReferralAmountUpdateType,
  ReferralLinkConfig,
  ReferralLinkConfigFilterInput,
  ReferralLinkConfigInput,
  ReferralLinkConfigPage,
  ReferralSettings,
  ReferralSettingsInput,
  ReferralUpdateInput,
  Referrals,
  ReferralsInput,
  ReferrerFilter,
  ReferrerType,
  RegionPlayerInfo,
  RegionPlayerInfoInput,
  RemovePlayerReferralInput,
  RemoveReferralLinkConfigInput,
  RepaymentLog,
  RepaymentLogsFilter,
  RepaymentLogsPage,
  ReportField,
  ReportLink,
  ReportingFilter,
  ReportingMarketing,
  ReportingMarketingMetrics,
  ReportingMarketingTimeSeries,
  ResourceType,
  ResultType,
  RevenueShareClaimInput,
  RevenueShareClaimResult,
  RevenueShareOfferingStatus,
  RevenueShareType,
  RgLimitType,
  RgMoneyLimitHistory,
  RgMoneyLimitHistoryInput,
  RgStateLimitHistory,
  RgStateLimitHistoryInput,
  RgTimeLimitHistory,
  RgTimeLimitHistoryInput,
  RgUserLimits,
  RgUserLimitsFilter,
  RgUserLimitsInput,
  SaveTurnoverConfig,
  ScopeType,
  SecurityCase,
  SecurityCaseInput,
  SecurityCaseType,
  SecurityCodeBusinessSwitch,
  SecurityCodeBusinessSwitchInput,
  SecurityCodeResetLog,
  SecurityCodeResetLogFilter,
  SecurityCodeResetLogPage,
  SecurityCodeStatus,
  SecurityCodesConfig,
  SecurityCodesConfigInput,
  SecurityLimitHistory,
  SecurityLimitHistoryInput,
  SecurityLimitType,
  SecurityPunishmentStatus,
  ShareSummary,
  SortOrder,
  Sorting,
  SourceOfFund,
  SourceOfFundType,
  SportsSummary,
  StatusReasonFilter,
  Subscription,
  SubscriptionFilter,
  SubscriptionListFilter,
  SyncKeycloakInput,
  TextFilter,
  Timestamp,
  TimestampInput,
  TotalGgrSummary,
  Transaction,
  TransactionAttemptsSummary,
  TransactionAttemptsSummaryInput,
  TransactionGroupSummary,
  TransactionGroupSummaryInput,
  TransactionHistory,
  TransactionHistoryInput,
  TransactionInput,
  TransactionStatus,
  TransactionSummary,
  TransactionSummaryInput,
  TransactionType,
  TriggerOutput,
  TurnoverConfig,
  TurnoverConfigFilter,
  TurnoverConfigPage,
  UpdateFailureTransactionInput,
  UpdateTurnoverConfig,
  UploadedDocumentFilter,
  UploadedDocumentPage,
  User2FaInput,
  UserAccountStatus,
  UserAction,
  UserActionHistoryPage,
  UserActionInput,
  UserActivitySummary,
  UserAddressInfo,
  UserAddressInfoInput,
  UserAssignInput,
  UserBetInput,
  UserBiggestValues,
  UserBiggestValuesInput,
  UserBlackList,
  UserBlackListInput,
  UserBusinessPool,
  UserChallengeQuestionInput,
  UserClub,
  UserClubsFilter,
  UserClubsPage,
  UserContactInfo,
  UserContactInfoInput,
  UserGame,
  UserGameInput,
  UserGamePage,
  UserIdentityInfo,
  UserIdentityInfoInput,
  UserIdentityInput,
  UserKycPage,
  UserLabel,
  UserLabelGroup,
  UserLabelGroupInput,
  UserLabelInput,
  UserLicenseInput,
  UserLogin,
  UserLoginFilter,
  UserLoginInput,
  UserLoginPage,
  UserLogout,
  UserLogoutInput,
  UserMarketingInfo,
  UserMarketingInfoInput,
  UserNetworkProfile,
  UserNetworkProfileInput,
  UserPage,
  UserProfile,
  UserProfileFilter,
  UserProfileInput,
  UserReCaptchaScore,
  UserReCaptchaScoreFilter,
  UserReCaptchaScoreInput,
  UserReCaptchaScorePage,
  UserReputationScore,
  UserReputationScoreFilter,
  UserReputationScoreInput,
  UserReputationScorePage,
  UserRgLimitsPage,
  UserSecuritySettings,
  UserSecuritySettingsInput,
  UserStatistics,
  UserStatisticsFilter,
  UserStatisticsGameType,
  UserStatisticsInput,
  UserStatisticsPage,
  UserTransactionFilter,
  UserTransactionPage,
  ValidationResult,
  VerificationCode,
  VerificationCodeFilter,
  VerificationCodePage,
  VerificationCodeStatus,
  VerificationCodeType,
  VerifiedContactInput,
  WeeklySummaryExport,
  WeeklySummaryExportPage,
  WhiteListInput,
  Workspace
};
//# sourceMappingURL=pam.js.map
